const messages = {
  pt: {
    translations: {
      common: {
        none: "Nenhuma",
        yes: "Sim",
        no: "Não",
        statusLabel: "Status",
        labels: {
          all: "Todos",
        },
        buttons: {
          save: "Salvar",
          cancel: "Cancelar",
          close: "Fechar",
          edit: "Editar",
          delete: "Excluir",
          create: "Criar",
          update: "Atualizar",
          saving: "Salvando...",
        },
        status: {
          active: "Ativa",
          inactive: "Inativa",
          enabled: "Habilitada",
          disabled: "Desabilitada",
        },
        toasts: {
          operationSuccess: "Operação realizada com sucesso!",
        },
      },
      signup: {
        title: "Cadastre-se",
        plan: {
          selected: "Plano Selecionado",
        },
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          disabled:
            "Cadastro de usuários está desabilitado no momento. Por favor, tente novamente mais tarde.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
        },
        errors: {
          registrationAlreadyExists: "Já existe um cadastro associado ao e-mail ou documento informado.",
          loginLink: "Se você já possui uma conta, entre para continuar.",
          loginButton: "Entrar",
        },
        country: {
          label: "País",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          company: "Nome da Organização",
          companyName: "Razão Social",
          tradeName: "Nome Fantasia",
          personName: "Nome completo",
          phone: "Whatsapp (DDD + NÚMERO)",
        },
        buttons: {
          continue: "Continuar",
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!",
        },
        step2: {
          reviewTitle: "Confira seus dados",
          manualTitle: "Complete seu cadastro",
          foundDataMessage: "Encontramos alguns dados associados ao seu documento.",
          documentLabel: "Documento",
          backButton: "Voltar e alterar documento",
        },
      },
      ticketInfo: {
        copyPhone: "Copiar telefone",
        quickMessages: "Respostas rápidas",
        phonecopied: "Telefone copiado para área de transferência!",
        noPhone: "Nenhum telefone disponível para copiar",
        copyError: "Erro ao copiar telefone",
      },
      login: {
        title: "Login",
        welcome: "Bem-vindo de volta",
        loginInstruction: "Entre com seus dados para acessar sua conta",
        form: {
          email: "Email",
          password: "Senha",
          button: "Acessar",
        },
        buttons: {
          submit: "Entrar",
          register: "Não tem um conta? Cadastre-se!",
        },
      },
      companies: {
        title: "Cadastrar Empresa",
        form: {
          name: "Nome da Empresa",
          plan: "Plano",
          token: "Token",
          submit: "Cadastrar",
          success: "Empresa criada com sucesso!",
          contactEmail: "Email de Contato *",
          adminEmail: "Email do Administrador *",
          timezone: "Timezone",
          recurrence: "Recorrência",
          generateInvoice: "Gerar Fatura",
        },
        toasts: {
          loadError: "Não foi possível carregar a lista de registros",
          operationError: "Não foi possível realizar a operação. Verifique se já existe uma empresa com o mesmo nome ou se os campos foram preenchidos corretamente",
          deleteError: "Não foi possível realizar a operação",
        },
        confirmation: {
          deleteTitle: "Exclusão de Registro",
          deleteMessage: "Deseja realmente excluir esse registro?",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
        },
        dueDate: {
          expiration: "Sua assinatura expira em",
          days: "dias!",
          day: "dia!",
          expirationToday: "Sua assinatura expira hoje!",
        },
        token: "Token",
      },
      dashboard: {
        title: "Dashboard",
        filters: "Filtros",
        sections: {
          performanceIndicators: "Indicadores de Performance",
          satisfactionSurvey: "Pesquisa de satisfação",
          hourlyDistribution: "Distribuição por horário",
          attendances: "Atendimentos",
          attendants: "Atendentes",
        },
        performance: {
          totalAttendances: "Total de atendimentos",
          closed: "Fechados",
          open: "Abertos",
          pending: "Pendentes",
          withoutQueue: "Sem Fila Definida",
          withoutUser: "Sem Atendente Definido",
          attendants: "Atendentes",
          averageServiceTime: "Tempo Médio de Atendimento",
          averageWaitingTime: "Tempo Médio Até o Início",
          newContacts: "Novos Contatos",
          details: "Grupos: {{groups}} | Privados: {{private}}",
        },
        toasts: {
          loadError: "Erro ao carregar dados do dashboard",
        },
        filter: "FILTRAR ",
        filterLabels: {
          period: "Filtro de Período",
          days: "{{count}} dias",
          dateRange: "Intervalo de Datas",
          queues: "Filas",
          attendants: "Atendentes",
          connections: "Conexões",
          channels: "Canais",
        },
        tabs: {
          indicators: "Indicadores",
          assessments: "NPS",
          attendants: "Atendentes",
        },
        charts: {
          perDay: {
            title: "Atendimentos hoje: ",
          },
        },
        cards: {
          inAttendance: "Em Atendimento",
          waiting: "Aguardando",
          activeAttendants: "Atendentes Ativos",
          finalized: "Finalizados",
          newContacts: "Novos Contatos",
          totalReceivedMessages: "Mensagens Recebidas",
          totalSentMessages: "Mensagens Enviadas",
          averageServiceTime: "T.M. de Atendimento",
          averageWaitingTime: "T.M. de Espera",
          status: "Status (Atual)",
          activeTickets: "Tickets Ativos",
          passiveTickets: "Tickets Passivos",
          groups: "Grupos",
        },
        users: {
          name: "Nome",
          numberAppointments: "Quantidade de Atendimentos",
          statusNow: "Atual",
          totalCallsUser: "Total de atendimentos por usuario",
          totalAttendances: "Total de atendimentos",
        },
        date: {
          initialDate: "Data Inicial",
          finalDate: "Data Final",
        },
        licence: {
          available: "Disponível até",
        },
        assessments: {
          totalCalls: "Total de Atendimentos",
          callsWaitRating: "Atendimentos aguardando avaliação",
          callsWithoutRating: "Atendimentos sem avaliação",
          ratedCalls: "Atendimentos avaliados",
          evaluationIndex: "Índice de avaliação",
          score: "Pontuação",
          prosecutors: "Promotores",
          neutral: "Neutros",
          detractors: "Detratores",
        },
      },
      reports: {
        title: "Relatório de Pesquisas Realizadas",

        operator: "Operador",
        period: "Período",
        until: "Até",
        date: "Data",
        reportTitle: "Relatórios",
        calls: "Atendimentos",
        search: "Pesquisas",
        durationCalls: "Duracão dos atendimentos",
        grupoSessions: "Atendimentos em grupos",
        groupTicketsReports: {
          timezone: "America/Sao_Paulo",
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          errorToast: "Erro ao gerar o relatório",
          back: "Voltar",
          groupServiceReport: "Relatório de Atendimento em Grupos",
          loading: "Carregando...",
          contact: "Contato",
          dateOpen: "Data abertura",
          dateLastUpdated: "Data Última Atualização",
          agent: "Quem atendeu",
          agentClosed: "Quem fechou",
          waitingAssistance: "Aguardando atendimento",
          process: "Em atendimento",
        },
        researchReports: {
          response: "resposta",
          active: "(Ativa)",
          inactive: "(Inativa)",
          quantity: "Quantidade",
          percentage: "porcentagem",
          title: "Relatório de Pesquisas Realizadas",
          activeSearch: "Pesquisa ativa",
          inactiveSearch: "Pesquisa inativa",
        },
        ticketDurationDetail: {
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          title: "Relatório de Duração do Atendimento",
          startService: "Início do atendimento",
          lastUpdated: "Última atualização",
          lastAgent: "Último atendente",
          durationFinished: "Duração após finalizado",
        },
        ticketDuration: {
          title: "Relatório de Duração dos Atendimento",
          contact: "Contato",
          open: "Abertos",
          pending: "Pendentes",
          finished: "Finalizados",
          durationFinished: "Duração dos finalizados",
          durationAfterFinished: "Duração após finalizado",
          actions: "Ações",
        },
        ticketReports: {
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          title: "Relatório de Atendimento",
        },
        exportExcel: {
          title: "Relatórios de Atendimentos",
          startDate: "Data inicial",
          endDate: "Data final",
          notInformed: "Não informado",
          columns: {
            id: "ID",
            connection: "Conexão",
            contact: "Contato",
            user: "Usuário",
            queue: "Fila",
            status: "Status",
            lastMessage: "Última Mensagem",
            openDate: "Data Abertura",
            openTime: "Hora Abertura",
            closeDate: "Data Fechamento",
            closeTime: "Hora Fechamento",
            supportTime: "Tempo de Atendimento",
            nps: "NPS",
          },
        },
        pdf: {
          title: "Relação de Atendimentos Realizados",
          exportTitle: "Relação de Atendimentos em Grupos Realizados",
        },
      },
      todo: {
        newTask: "Nova Tarefa",
        add: "Adicionar",
        task: "Tarefas",
      },
      contactImportWpModal: {
        title: "Exportar Contatos para o Excel",
        buttons: {
          downloadModel: "Download modelo do excel para importação",
          closed: "Fechar",
          import: "Selecione o arquivo do excel para importar Contatos",
        },
      },
      connections: {
        title: "Conexões",
        waitConnection: "Aguarde... Suas conexões serão reiniciadas!",
        newConnection: "Nova Conexão",
        restartConnections: "Reiniciar Conexões",
        callSupport: "Chamar Suporte",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          " Conecte seus canais de atendimento para receber mensagens e iniciar conversas com seus clientes.",
        client: "Cliente",
        connectedConnections: " Conexões conectadas ",
        disconnectedConnections: "Conexões desconectadas ",
        totalConnections: " Total de Conexões",
        total: "Total",
        connections: "Conexões de:",

        toasts: {
          deleted: "Conexão excluída com sucesso!",
          loadError: "Não foi possível carregar a lista de registros",
          closedimported:
            "Estamos fechando os tickets importados, por favor aguarde uns instantes",
        },
        confirmationModal: {
          closedImportedTitle: "Fechar tickets importados",
          closedImportedMessage:
            "Se você confirmar todos os tickets importados serão fechados",
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza? Você precisará ler o QR Code novamente.",
        },
        buttons: {
          add: "Adicionar Conexão",
          disconnect: "Desconectar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          closedImported: "Fechar todos os tickets Importados",
          preparing: "Preparando mensagens para importação",
          importing: "Importando Mensagens do WhatsApp",
          processed: "Processado",
          in: "de",
          connecting: "Conectando",
        },
        typography: {
          processed: "Processado",
          in: "de",
          date: "Data da mensagem",
        },
        table: {
          name: "Nome",
          status: "Status",
          lastUpdate: "Última atualização",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
          number: "Número do Whatsapp",
          color: "Cor",
          receiveComments: "Receber Comentários",
        },
        receiveComments: {
          enabled: "Recebimento de comentários habilitado",
          disabled: "Recebimento de comentários desabilitado",
          tooltip: {
            enabled: "Comentários estão sendo recebidos. Clique para desabilitar.",
            disabled: "Comentários não estão sendo recebidos. Clique para habilitar.",
          },
        },
        tooltips: {
          edit: "Editar conexão",
          delete: "Excluir conexão",
          syncTemplates: "Sincronizar templates",
          copyWebhook: "Copiar webhook para Meta",
          transferTickets: "Transferir tickets entre conexões",
          restartConnections: "Reiniciar todas as conexões",
          callSupport: "Chamar suporte via WhatsApp",
          newConnection: "Adicionar nova conexão",
          qrcode: "Exibir QR Code para conectar",
          tryAgain: "Tentar reconectar",
          newQr: "Gerar novo QR Code",
          disconnect: "Desconectar sessão",
          connecting: "Aguarde, conectando...",
          defaultConnection: "Esta é a conexão padrão",
          channelWhatsapp: "Canal: WhatsApp",
          channelWhatsappOfficial: "Canal: WhatsApp Oficial (API Cloud)",
          channelFacebook: "Canal: Facebook Messenger",
          channelInstagram: "Canal: Instagram Direct",
          closedImported: "Fechar todos os tickets que foram importados do histórico",
          preparing: "Preparando mensagens para importação...",
          importMessages: "Importar histórico de mensagens do WhatsApp",
        },
        toolTips: {
          opening: {
            title: "Aguardando conexão",
            content: "O sistema está tentando conectar. Aguarde ou clique em 'Novo QR Code' para gerar um novo código.",
          },
          disconnected: {
            title: "Falha ao iniciar sessão do WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: "Desconectar sessão",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
          restarting: {
            title: "Reiniciando conexão",
            content: "A conexão está sendo reiniciada automaticamente. Aguarde alguns instantes...",
          },
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Atendimento Existente",
        },
        form: {
          message: "Este contato já está em atendimento:",
          user: "Atendente",
          queue: "Fila",
          messageWait:
            "Este contato já está aguardando atendimento. Veja na aba Aguardando!",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Logs",
        },
        options: {
          create: "Ticket criado.",
          chatBot: "ChatBot iniciado.",
          queue: " - Fila definida.",
          open: " iniciou o atendimento.",
          access: "acessou o ticket.",
          transfered: "transferiu o ticket.",
          receivedTransfer: "recebeu o ticket transferido.",
          pending: "devolveu a fila.",
          closed: "fechou o ticket",
          reopen: "reabriu o ticket",
          redirect: "- redirecionado",
          clientClosed: "Cliente fechou o ticket",
        },
      },
      whatsappModal: {
        title: {
          add: "Adicionar Conexão",
          edit: "Editar Conexão",
        },
        tabs: {
          general: "Geral",
          messages: "Mensagens",
          assessments: "NPS",
          integrations: "Integrações",
          schedules: "Horário de expediente",
        },
        form: {
          importOldMessagesEnable: "Importar mensagens do aparelho",
          importOldMessages: "Data de inicio da importação",
          importRecentMessages: "Data de termino da importação",
          importOldMessagesGroups: "Importar mensagens de grupo",
          closedTicketsPostImported: "Encerrar tickets após importação",
          name: "Nome",
          queueRedirection: "Redirecionamento de Fila",
          queueRedirectionDesc:
            "Selecione uma fila para os contatos que não possuem fila serem redirecionados",
          default: "Padrão",
          group: "Permitir grupos",
          timeSendQueue: "Tempo em minutos para redirecionar para fila",
          importAlert:
            "ATENÇÃO: Ao salvar, sua conexão será encerrada, será necessário ler novamente o QR Code para importar as mensagens",
          groupAsTicket: "Tratar grupos como ticket",
          timeCreateNewTicket: "Criar novo ticket em x minutos",
          maxUseBotQueues: "Enviar bot x vezes",
          maxUseInactiveTime: "Enviar flow de inatividade x vezes",
          timeUseBotQueues: "Enviar bot em x minutos",
          timeToReturnQueue: "Tempo para retornar a fila em minutos",
          timeAwaitActiveFlow: "Tempo para aguardar ativação do fluxo",
          expiresTicket: "Encerrar chats abertos após x minutos",
          expiresTicketNPS:
            "Encerrar chats aguardando avaliação após x minutos",
          maxUseBotQueuesNPS:
            "Quantidade máxima de vezes que a avaliaçao vai ser enviada",
          closeLastMessageOptions1: "Do atendente/Cliente",
          closeLastMessageOptions2: "Do atendente",
          outOfHoursMessage: "Mensagem de fora de expediente",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          lgpdLinkPrivacy: "Link para política de privacidade",
          lgpdMessage: "Mensagem de saudaçao LGPD",
          lgpdDeletedMessages: "Ofuscar mensagem apagada pelo contato",
          lgpdSendMessage: "Sempre solicitar confirmação do contato",
          ratingMessage: "Mensagem de avaliaçao - Escala deve ser de 0 a 10",
          token: "Token para integração externa",
          sendIdQueue: "Fila",
          inactiveMessage: "Mensagem de inatividade",
          timeInactiveMessage:
            "Tempo em minutos para envio do aviso de inatividade",
          flowInactiveTime:
            "Tempo em minutos para envio do flow de inatividade",
          whenExpiresTicket:
            "Encerrar chats abertos quando última mensagem for",
          expiresInactiveMessage: "Mensagem de encerramento por inatividade",
          prompt: "Prompt",
          collectiveVacationEnd: "Data final",
          collectiveVacationStart: "Data inicial",
          collectiveVacationMessage: "Mensagem de férias coletivas",
          queueIdImportMessages: "Fila para importar as mensagens",
          isOficial: "Oficial",
          phone_number_id: "ID Número de telefone",
          waba_id: "Waba ID",
          send_token: "Token de envio",
          business_id: "ID do negócio",
          phone_number: "Número de telefone",
          triggerIntegrationOnClose: "Disparar Integração ao Encerrar Ticket",
          enableIntegration: "Habilitar Integração",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        menuItem: {
          enabled: "Habilitado",
          disabled: "Desabilitado",
          minutes: "minutos",
        },
        success: "Conexão salvo com sucesso.",
        errorSendQueue:
          "Foi informado tempo para redirecionar fila, porém não foi selecionada fila para redirecionar. Os dois campos precisam estar preenchidos",
        errorExpiresNPS:
          "É obrigado informar um tempo para avaliação quando se utiliza o NPS.",
        errorRatingMessage:
          "É obrigado informar uma mensagem de avaliação quando se utiliza o NPS.",
      },
      qrCode: {
        title: "Conectar WhatsApp",
        message: "Leia o QrCode para iniciar a sessão",
        waiting: "Aguardando QR Code...",
      },
      contacts: {
        title: "Contatos",
        profileImageTitle: "Foto de Perfil",
        toasts: {
          deleted: "Contato excluído com sucesso!",
          blocked: "Contato bloqueado",
          unblocked: "Contato desbloqueado",
        },
        searchPlaceholder: "Pesquisar...",
        conversationFlows: " Fluxos de Conversa",
        addFlow: "Adicionar Fluxo",
        editFlow: "Editar Fluxo ",
        confirmationModal: {
          deleteTitle: "Deletar ",
          importTitlte: "Importar contatos",
          exportContact: "Exportar contatos",
          deleteMessage:
            "Tem certeza que deseja deletar este contato? Todos os atendimentos relacionados serão perdidos.",
          blockContact: "Tem certeza que deseja bloquear este contato?",
          unblockContact: "Tem certeza que deseja desbloquear este contato?",
          importMessage: "Deseja importar todos os contatos do telefone?",
          importChat: "Importar Conversas",
          wantImport: "Deseja importar todas as conversas do telefone?",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
          export: "Exportar Contato",
        },
        loading: "Carregando...",
        loadMore: "Carregar Mais",
        table: {
          name: "Nome",
          whatsapp: "WhatsApp",
          email: "Email",
          photo: "Foto",
          status: "Status",
          actions: "Ações",
          lastMessage: "Última Mensagem",
          wallet: "Carteira",
        },
        bulk: {
          deleteAllWithCount: "Excluir Todos ({{count}})",
          deleteSelectedWithCount: "Excluir Selecionados ({{count}})",
          delete: "Excluir",
          selectedSummary: "{{count}} selecionado(s)",
          selectedContactsSummary: "{{count}} contato(s) selecionado(s)",
          allShort: "(TODOS)",
          allContacts: "(TODOS OS CONTATOS)",
          deleteAllTooltip: "Excluir todos os contatos",
          deleteSelectedTooltip: "Excluir contatos selecionados",
          deleteSelected: "Excluir selecionados",
          deleteAllContacts: "Excluir Todos os Contatos",
          cancelSelection: "Cancelar seleção",
          selectAllAria: "Selecionar todos os contatos",
        },
        tooltips: {
          sendMessage: "Enviar mensagem via WhatsApp",
          edit: "Editar contato",
          block: "Bloquear contato",
          unblock: "Desbloquear contato",
          delete: "Excluir contato",
        },
        menu: {
          importYourPhone: "Importar do aparelho padrão",
          importToExcel: "Importar / Exportar do Excel",
          importexport: "IMPORTAR / EXPORTAR ",
        },
        fixContactsLid: {
          title: "Saneamento de Contatos (LID)",
          button: "Corrigir LID",
          tooltip: "Corrigir contatos duplicados onde LID foi salvo como número",
          start: "Iniciar",
          close: "Fechar",
          details: "Detalhamento",
          steps: {
            idle: "Aguardando",
            starting: "Iniciando",
            identifying: "Identificando contatos",
            finding: "Buscando contatos reais",
            merging: "Mesclando contatos",
            completed: "Concluído",
            error: "Erro",
          },
        },
        importProgress: {
          title: "Importar Contatos do Aparelho",
          starting: "Iniciando importação...",
          startingImport: "Iniciando importação...",
          searching: "Buscando contatos do aparelho...",
          importing: "Importando contatos...",
          importError: "Erro ao importar contatos",
          processing: "Processando",
          processingGroups: "📁 Processando Grupos",
          processingContacts: "👥 Processando Contatos",
          processed: "Processado",
          of: "de",
          contacts: "contatos",
          fetchingWhatsapp: "Buscando dados do WhatsApp...",
          groupsTitle: "📁 Grupos ({{count}})",
          contactsTitle: "👥 Contatos ({{count}})",
          whatsappWebNoSync: "O WhatsApp Web não sincroniza a lista de contatos automaticamente.",
          contactsCreatedOnMessages: "Contatos são criados quando você envia ou recebe mensagens.",
          duration: "Tempo de execução: {{seconds}}s",
          completed: "Importação concluída!",
          created: "contatos criados",
          updated: "contatos atualizados",
          skipped: "ignorados",
          error: "Erro na importação",
          closeAndRefresh: "Fechar e Atualizar",
          close: "Fechar",
        },
      },
      forwardMessage: {
        text: "Encaminhada",
      },
      forwardMessageModal: {
        title: "Encaminhar mensagem",
        buttons: {
          ok: "Encaminhar",
        },
      },
      promptModal: {
        form: {
          name: "Nome",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Máximo de Tokens na resposta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensagens no Histórico",
          voiceKey: "Chave da API de Voz",
          voiceRegion: "Região de Voz",
        },
        success: "Prompt salvo com sucesso!",
        title: {
          add: "Adicionar Prompt",
          edit: "Editar Prompt",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nome",
          queue: "Setor/Fila",
          max_tokens: "Máximo Tokens Resposta",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida!",
        },
        buttons: {
          add: "Adicionar Prompt",
        },
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do Whatsapp",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
          chatBotContact: "Desabilitar chatbot",
          termsLGDP: "Termos LGPD aceito em:",
          whatsapp: "Conexão Origem: ",
          assignWallet: "Carteira de Cliente",
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
        walletLinked: "Contato vinculado à sua carteira com sucesso!",
        walletError: "Usuário não possui filas associadas",
        saveFirst: "Contato deve ser salvo primeiro",
      },
      wallets: {
        title: "Carteiras de Contatos",
        searchPlaceholder: "Buscar contatos...",
        filterByUser: "Filtrar por Usuário",
        allUsers: "Todos os usuários",
        contact: "Contato",
        user: "Usuário",
        queue: "Fila",
        phone: "Telefone",
        email: "Email",
        actions: "Ações",
        editWallet: "Editar Carteira",
        selectUser: "Selecionar Usuário",
        selectQueue: "Selecionar Fila",
        selectUserAndQueue: "Selecione um usuário e uma fila",
        cancel: "Cancelar",
        save: "Salvar",
        confirmDeleteTitle: "Confirmar Exclusão",
        confirmDeleteMessage:
          "Tem certeza que deseja remover este contato da carteira?",
        deleteSuccess: "Contato removido da carteira com sucesso!",
        updateSuccess: "Carteira atualizada com sucesso!",
        wallet: "Carteira",
      },
      queueModal: {
        title: {
          queueData: "Dados da fila",
          text: "Horários de atendimento",
          add: "Adicionar fila",
          edit: "Editar fila",
          confirmationDelete:
            "Tem certeza? Todas as opções de integrações serão deletadas.",
        },
        form: {
          name: "Nome",
          color: "Cor",
          orderQueue: "Ordem da fila (Bot)",
          rotate: "Rodízio",
          timeRotate: "Tempo de Rodízio",
          typeRandomMode: "Tipo de rodízio",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          outOfHoursMessage: "Mensagem de fora de expediente",
          token: "Token",
          integrationId: "Integração",
          fileListId: "Lista de arquivos",
          closeTicket: "Fechar ticket",
          randomizeImmediate: "Randomizar Automaticamente (Imediato)",
          queueType: "Tipo de menu",
          message: "Mensagem de retorno",
          queue: "Fila para transferência",
          integration: "Integração",
          file: "Lista de arquivos",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        bot: {
          title: "Opções",
          toolTipTitle: "Adicione opções para construir um chatbot",
          toolTip:
            "Se houver apenas uma opção, ela será escolhida automaticamente, fazendo com que o bot responda com a mensagem da opção e siga adiante",
          selectOption: "Selecione uma opção",
          text: "Texto",
          attendent: "Atendente",
          queue: "Fila",
          integration: "Integração",
          file: "Arquivo",
          toolTipMessageTitle:
            "A mensagem é obrigatória para seguir ao próximo nível",
          toolTipMessageContent:
            "A mensagem é obrigatória para seguir ao próximo nível",
          selectUser: "Selecione um Usuário",
          selectQueue: "Selecione uma Fila",
          selectIntegration: "Selecione uma Integração",
          addOptions: "Adicionar opções",
        },
        serviceHours: {
          dayWeek: "Dia da semana",
          startTimeA: "Hora Inicial - Turno A",
          endTimeA: "Hora Final - Turno A",
          startTimeB: "Hora Inicial - Turno B",
          endTimeB: "Hora Final - Turno B",
          monday: "Segunda-feira",
          tuesday: "Terça-feira",
          wednesday: "Quarta-feira",
          thursday: "Quinta-feira",
          friday: "Sexta-feira",
          saturday: "Sábado",
          sunday: "Domingo",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Adicionar projeto",
          edit: "Editar projeto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tempo em minutos para expirar uma conversa",
          typebotKeywordFinish: "Palavra para finalizar o ticket",
          typebotKeywordRestart: "Palavra para reiniciar o fluxo",
          typebotRestartMessage: "Mensagem ao reiniciar a conversa",
          typebotUnknownMessage: "Mensagem de opção inválida",
          typebotDelayMessage: "Intervalo (ms) entre mensagens",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          test: "Testar Bot",
        },
        messages: {
          testSuccess: "Integração testada com sucesso!",
          addSuccess: "Integração adicionada com sucesso.",
          editSuccess: "Integração editada com sucesso.",
        },
      },
      userModal: {
        warning:
          "Para fazer a importação das mensagens é necessário ler o qrCode novamente !!!",
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
          updateImage: "Atualizar imagem",
          removeImage: "Excluir imagem",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          farewellMessage: "Mensagem de despedida",
          profile: "Perfil",
          startWork: "Inicio de trabalho",
          endWork: "Fim de trabalho",
          whatsapp: "Conexão Padrão",
          allTicketEnable: "Habilitado",
          allTicketDisable: "Desabilitado",
          allTicket: "Visualizar chamados sem fila",
          allowGroup: "Permitir Grupos",
          defaultMenuOpen: "Aberto",
          defaultMenuClosed: "Fechado",
          defaultMenu: "Menu padrão",
          defaultTheme: "Tema Padrão",
          defaultThemeDark: "Escuro",
          defaultThemeLight: "Claro",
          allHistoric: "Ver conversas de outras filas",
          allHistoricEnabled: "Habilitado",
          allHistoricDisabled: "Desabilitado",
          allUserChat: "Ver conversas de outros usuários",
          userClosePendingTicket: "Permitir fechar tickets pendentes",
          allowSeeMessagesInPendingTickets: "Permitir ver tickets pendentes",
          showDashboard: "Ver Dashboard",
          allowRealTime: "Ver Painel de Atendimentos",
          allowConnections: "Permitir ações nas conexões",
          showContacts: "Ver contatos",
          showCampaign: "Ver campanhas",
          showFlow: "Ver automações",
        },
        tabs: {
          general: "Geral",
          permissions: "Permissões",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          addImage: "Adicionar Imagem",
          editImage: "Editar Imagem",
        },
        success: "Usuário salvo com sucesso.",
      },
      companyModal: {
        title: {
          add: "Adicionar empresa",
          edit: "Editar empresa",
        },
        form: {
          name: "Nome",
          email: "Email",
          passwordDefault: "Senha",
          numberAttendants: "Usuários",
          numberConections: "Conexões",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Empresa salvo com sucesso.",
      },
      scheduleModal: {
        title: {
          add: "Novo Agendamento",
          edit: "Editar Agendamento",
          message: "Mensagem",
        },
        form: {
          body: "Mensagem",
          contact: "Contato",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          assinar: "Enviar Assinatura",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          addSchedule: "Adicionar agendamento",
        },
        success: "Agendamento salvo com sucesso.",
      },
      tagModal: {
        title: {
          add: "Nova Tag",
          edit: "Editar Tag",
          addKanban: "Nova Lane",
          editKanban: "Editar Lane",
        },
        form: {
          name: "Nome",
          color: "Cor",
          timeLane: "Tempo em minutos para redirecionar para lane",
          nextLaneId: "Lane",
          greetingMessageLane: "Mensagem de saudação da lane",
          mediaFiles: "Mídia",
          rollbackLaneId: "Voltar para Lane após retomar atendimento",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Tag salva com sucesso.",
        successKanban: "Lane salva com sucesso.",
      },
      fileModal: {
        title: {
          add: "Adicionar lista de arquivos",
          edit: "Editar lista de arquivos",
        },
        buttons: {
          okAdd: "Salvar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Adicionar arquivo",
        },
        form: {
          name: "Nome da lista de arquivos",
          message: "Detalhes da lista",
          fileOptions: "Lista de arquivos",
          extraName: "Mensagem para enviar com arquivo",
          extraValue: "Valor da opção",
        },
        success: "Lista de arquivos salva com sucesso!",
      },
      chat: {
        noTicketMessage: "Selecione um ticket para começar a conversar.",
        toasts: {
          exists: "Chat com este usuário já existe!",
          saveError: "Erro ao criar/editar chat",
          loadUsersError: "Erro ao carregar usuários",
          created: "Chat criado com sucesso!",
          createError: "Erro ao criar chat",
        },
        groupPhoto: {
          change: "Alterar Foto do Grupo",
          add: "Adicionar Foto do Grupo",
        },
        form: {
          title: "Título",
          description: "Descrição",
          groupDescriptionPlaceholder: "Descrição do grupo",
        },
        alerts: {
          editWindowExpired: "Só é possível editar mensagens enviadas há menos de 10 minutos.",
        },
        modals: {
          editMessage: {
            title: "Editar Mensagem",
            message: "Mensagem",
          },
          forwardMessage: {
            title: "Encaminhar Mensagem",
            selectChat: "Selecione o chat",
            forward: "Encaminhar",
          },
        },
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop:
            "⬇️ ARRASTE E SOLTE ARQUIVOS NO CAMPO ABAIXO ⬇️",
          titleFileList: "Lista de arquivo(s)",
        },
      },
      chatInternal: {
        new: "Criar grupo",
        modal: {
          conversation: "Conversa",
          title: "Nome",
          filterUsers: "Selecione integrantes",
          cancel: "Fechar",
          save: "Salvar",
        },
        modalDelete: {
          title: "Excluir Conversa",
          message: "Esta ação não pode ser revertida, confirmar?",
        },
      },
      ticketsManager: {
        questionCloseTicket: "VOCÊ DESEJA FECHAR TODOS OS TICKETS?",
        yes: "SIM",
        not: "NÃO",
        buttons: {
          newTicket: "Novo",
          resolveAll: "Resolver Todos",
          close: "Fechar",
          new: "Novo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        messageHidden: "Mensagem oculta",
        inbox: {
          closedAllTickets: "Fechar todos os tickets?",
          closedAll: "Fechar Todos",
          newTicket: "Novo Ticket",
          yes: "SIM",
          no: "NÃO",
          open: "Abertos",
          resolverd: "Resolvidos",
        },
        toasts: {
          deleted: "O atendimento que você estava foi deletado.",
        },
        notification: {
          message: "Mensagem de",
          messageHidden: "Mensagem oculta",
        },
        tabs: {
          open: { title: "Abertas" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar atendimento e mensagens",
          filterConections: "Filtro por Conexão",
          filterConectionsOptions: {
            open: "Aberto",
            closed: "Fechado",
            pending: "Pendente",
          },
          filterUsers: "Filtro por Usuarios",
          filterContacts: "Filtro por Contatos",
          ticketsPerPage: "Tickets por página",
        },
        buttons: {
          showAll: "Todos",
          returnQueue: "Devolver a Fila",
          scredule: "Agendamento",
          deleteTicket: "Deletar Ticket",
        },
        closedTicket: {
          closedMessage: "Fechar Ticket Com Mensagem de Despedida",
          closedNotMessage: "Fechar Ticket Sem Mensagem de Despedida",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Digite para buscar usuários",
        fieldQueueLabel: "Transferir para fila",
        fieldQueuePlaceholder: "Selecione uma fila",
        fieldWhatsapp: "Selecione um whatsapp",
        noOptions: "Nenhum usuário encontrado com esse nome",
        msgTransfer: "Observações - mensagem interna, não vai para o cliente",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      chatInternal: {
        new: "Criar grupo",
        modal: {
          conversation: "Conversa",
          title: "Nome",
          filterUsers: "Selecione integrantes",
          cancel: "Fechar",
          save: "Salvar",
        },
        modalDelete: {
          title: "Excluir Conversa",
          message: "Esta ação não pode ser revertida, confirmar?",
        },
      },
      ticketsList: {
        called: "Chamado",
        today: "Hoje",
        missedCall: "Chamada de voz/vídeo perdida às",
        pendingHeader: "Aguardando",
        assignedHeader: "Atendendo",
        allHeader: "Todos",
        groupingHeader: "Grupos",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
          "Nenhum atendimento encontrado com esse status ou termo pesquisado",
        noQueue: "Sem Fila",
        buttons: {
          accept: "Aceitar",
          cancel: "Cancelar",
          start: "iniciar",
          closed: "Fechar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          exportAsPDF: "Exportar para PDF",
          kanbanActions: "Opções de Kanban",
        },
        acceptModal: {
          title: "Aceitar Chat",
          queue: "Selecionar setor",
        },
      },
      newTicketModal: {
        title: "Criar Ticket",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Salvar",
          cancel: "Cancelar",
        },
      },
      SendContactModal: {
        title: "Enviar contato",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexões",
          chatsTempoReal: "Painel",
          tickets: "Atendimentos",
          quickMessages: "Respostas rápidas",
          contacts: "Contatos",
          wallets: "Carteiras",
          queues: "Filas & Chatbot",
          tags: "Tags",
          administration: "Administração",
          companies: "Empresas",
          users: "Usuários",
          birthdaySettings: "Config. Aniversário",
          settings: "Configurações",
          files: "Lista de arquivos",
          helps: "Ajuda",
          messagesAPI: "API",
          schedules: "Agendamentos",
          campaigns: "Campanhas",
          annoucements: "Informativos",
          chats: "Chat Interno",
          chatInternal: "Chat Interno",
          financeiro: "Financeiro",
          queueIntegration: "Integrações",
          version: "Versão",
          kanban: "Kanban",
          prompts: "Talk.Ai",
          allConnections: "Gerenciar conexões",
          reports: "Relatórios",
          management: "Gerência",
          callHistorical: "Histórico de Chamadas",
          automations: "Automações",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Sair",
            message: "Olá",
            messageEnd: "seja bem-vindo a",
            active: "Ativo até",
            goodMorning: "Oi,",
            myName: "meu nome é",
            continuity: "e darei continuidade em seu atendimento.",
            virtualAssistant: "Assistente Virtual",
            token:
              "Token inválido, por favor entre em contato com o administrador da plataforma.",
          },
          message: {
            location: "Localização",
            contact: "Contato",
          },
          notRegister: "Nenhum registro",
          refresh: "Atualizar",
          tooltips: {
            menu: "Abrir menu",
            language: "Alterar idioma",
            toggleTheme: "Alternar tema claro/escuro",
            volume: "Configurações de volume",
            refresh: "Atualizar página",
            notifications: "Notificações",
            announcements: "Informativos",
            chat: "Chat interno",
            userMenu: "Menu do usuário",
          },
        },
      },
      languages: {
        undefined: "Idioma",
        "pt-BR": "Português",
        es: "Español",
        en: "English",
        tr: "Türkçe",
      },
      messagesAPI: {
        title: "API",
        toSend: "ENVIAR",
        textMessage: {
          number: "Número",
          body: "Mensagem",
          token: "Token cadastrado",
          userId: "ID do usuário/atendente",
          queueId: "ID da Fila",
        },
        mediaMessage: {
          number: "Número",
          body: "Nome do arquivo",
          media: "Arquivo",
          token: "Token cadastrado",
        },
        API: {
          title: "Documentação para envio de mensagens",
          methods: {
            title: "Métodos de Envío",
            messagesText: "Mensagens de Texto",
            messagesMidia: "Mensagens de Media",
          },
          instructions: {
            title: "Instruções",
            comments: "Observações Importantes",
            comments1:
              "Antes de enviar mensagens, é necessário o cadastro do token vinculado à conexão que enviará as mensagens. <br />Para realizar o cadastro acesse o menu 'Conexões', clique no botão editar da conexão e insira o token no devido campo.",
            comments2:
              "O número para envio não deve ter mascara ou caracteres especiais e deve ser composto por:",
            codeCountry: "Código do País",
            code: "DDD",
            number: "Número",
          },
          text: {
            title: "1. Mensagens de Texto",
            instructions:
              "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:",
          },
          media: {
            title: "2. Mensagens de Media",
            instructions:
              "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:",
          },
        },
      },
      notifications: {
        noTickets: "Nenhuma notificação.",
        messageHidden: "Mensagem oculta",
        newMessage: "Nova mensagem de",
      },
      triggerFlowModal: {
        title: "Disparar Fluxo",
        description:
          "Selecione um fluxo para executar neste ticket. O ticket será alterado para status 'chatbot' durante a execução.",
        selectFlow: "Escolha um fluxo",
        selectedFlow: "Fluxo selecionado",
        flowId: "ID do fluxo",
        noFlows: "Nenhum fluxo ativo encontrado",
        cancel: "Cancelar",
        trigger: "Disparar Fluxo",
        triggering: "Disparando...",
        success: "Fluxo disparado com sucesso!",
        error: "Erro ao disparar fluxo",
      },
      quickMessages: {
        title: "Respostas Rápidas",
        searchPlaceholder: "Pesquisar...",
        noAttachment: "Sem anexo",
        confirmationModal: {
          deleteTitle: "Exclusão",
          deleteMessage: "Esta ação é irreversível! Deseja prosseguir?",
        },
        selectMessage: "Selecionar Resposta Rápida",
        hasMedia: "Com mídia",
        global: "Global",
        noResultsFound: "Nenhuma resposta rápida encontrada para sua busca",
        noQuickMessages: "Nenhuma resposta rápida disponível",
        buttons: {
          add: "Adicionar",
          attach: "Anexar Arquivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "Atalho adicionado com sucesso!",
          deleted: "Atalho removido com sucesso!",
        },
        dialog: {
          title: "Mensagem Rápida",
          shortcode: "Atalho",
          message: "Resposta",
          save: "Salvar",
          cancel: "Cancelar",
          geral: "Permitir editar",
          add: "Adicionar",
          edit: "Editar",
          general: "Geral",
          visao: "Permitir visão",
        },
        table: {
          shortcode: "Atalho",
          message: "Mensagem",
          actions: "Ações",
          mediaName: "Nome do Arquivo",
          status: "Status",
        },
      },
      contactLists: {
        title: "Listas de Contatos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Lista",
        },
        dialog: {
          name: "Nome",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          deleted: "Registro excluído",
          saved: "Lista salva com sucesso",
        },
      },
      contactListItems: {
        title: "Contatos",
        searchPlaceholder: "Pesquisa",
        buttons: {
          add: "Novo",
          lists: "Listas",
          import: "Importar",
        },
        dialog: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
          importMessage: "Deseja importar os contatos desta planilha? ",
          importTitlte: "Importar",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },

      kanban: {
        title: "Kanban",
        searchPlaceholder: "Pesquisa",
        subMenus: {
          list: "Painel",
          tags: "Lanes",
        },
      },

      campaigns: {
        title: "Campanhas",
        searchPlaceholder: "Pesquisa",
        subMenus: {
          list: "Minhas Campanhas",
          listContacts: "Lista de contatos",
          settings: "Configurações",
        },
        settings: {
          randomInterval: "Intervalo Randômico de Disparo",
          noBreak: "Sem Intervalo",
          intervalGapAfter: "Intervalo maior após",
          undefined: "Não definido",
          messages: "mensagens",
          laggerTriggerRange: "Intervalo de disparo maior",
          addVar: "Adicionar variável",
          save: "Salvar",
          close: "Fechar",
          add: "Adicionar",
          shortcut: "Atalho",
          content: "Conteúdo",
        },
        buttons: {
          add: "Nova Campanha",
          contactLists: "Listas de Contatos",
        },
        table: {
          name: "Nome",
          whatsapp: "Conexão",
          contactList: "Lista de Contatos",
          option: "Nenhuma",
          disabled: "Desabilitada",
          enabled: "Habilitada",
          status: "Status",
          scheduledAt: "Agendamento",
          recurrence: "Recorrência",
          nextExecution: "Próxima Execução",
          completedAt: "Concluída",
          confirmation: "Confirmação",
          actions: "Ações",
        },
        dialog: {
          new: "Nova Campanha",
          update: "Editar Campanha",
          readonly: "Apenas Visualização",
          help: "Utilize variáveis como {nome}, {numero}, {email} ou defina variáveis personalizadas.",
          form: {
            name: "Nome",
            message1: "Mensagem 1",
            message2: "Mensagem 2",
            message3: "Mensagem 3",
            message4: "Mensagem 4",
            message5: "Mensagem 5",
            confirmationMessage1: "Mensagem de Confirmação 1",
            confirmationMessage2: "Mensagem de Confirmação 2",
            confirmationMessage3: "Mensagem de Confirmação 3",
            confirmationMessage4: "Mensagem de Confirmação 4",
            confirmationMessage5: "Mensagem de Confirmação 5",
            messagePlaceholder: "Conteúdo da mensagem",
            whatsapp: "Conexão",
            status: "Status",
            scheduledAt: "Agendamento",
            confirmation: "Confirmação",
            contactList: "Lista de Contato",
            tagList: "Tags",
            statusTicket: "Status do Ticket",
            openTicketStatus: "Aberto",
            pendingTicketStatus: "Pendente",
            closedTicketStatus: "Fechado",
            enabledOpenTicket: "Habilitado",
            disabledOpenTicket: "Desabilitado",
            openTicket: "Abrir ticket",
            variablesHelper: "💡 Digite @ para inserir variáveis dinâmicas (ex: {{name}}, {{contactNumber}}, {{contactEmail}})",
          },
          validation: {
            tooShort: "Muito curto!",
            tooLong: "Muito longo!",
            required: "Obrigatório",
            connectionRequired: "Conexão é obrigatória",
            recurrenceTypeRequired: "Tipo de recorrência é obrigatório",
            intervalGreaterThanZero: "Intervalo deve ser maior que 0",
            intervalRequired: "Intervalo é obrigatório",
            weekDayRequired: "Selecione pelo menos um dia da semana",
          },
          recurrence: {
            title: "Configuração de Recorrência",
            enable: "Habilitar recorrência",
            type: "Tipo de Recorrência",
            interval: "Intervalo",
            intervalHelper: "A cada {{interval}} {{unit}}",
            weekDays: "Dias da Semana",
            dayOfMonth: "Dia do Mês",
            dayOfMonthHelper: "Dia específico do mês (1-31)",
            endDate: "Data Final (opcional)",
            maxExecutions: "Máximo de Execuções (opcional)",
            infiniteHelper: "Deixe vazio para recorrência infinita",
            hideNextExecutions: "Ocultar Próximas Execuções",
            showNextExecutions: "Visualizar Próximas Execuções",
            nextFiveExecutions: "Próximas 5 Execuções:",
            executionNumber: "{{count}}ª Execução",
            units: {
              minutes: "minuto(s)",
              hours: "hora(s)",
              days: "dia(s)",
              weeks: "semana(s)",
              biweeks: "quinzena(s)",
              months: "mês(es)",
              years: "ano(s)",
            },
          },
          messageTab: "Msg. {{count}}",
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar Disparos",
            restart: "Reiniciar Disparos",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
          stopRecurrenceTitle: "Interromper Recorrência",
          stopRecurrenceMessage: "Tem certeza que deseja interromper a recorrência desta campanha? A campanha atual continuará sendo executada, mas não haverão mais execuções futuras.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          pause: "Campanha pausada",
          cancel: "Campanha cancelada",
          restart: "Campanha reiniciada",
          deleted: "Registro excluído",
          noPermissionRedirect: "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.",
          stopRecurrence: "Recorrência interrompida com sucesso!",
        },
        filters: {
          status: "Filtrar por Status",
          recurrence: "Filtrar por Recorrência",
          all: "Todos",
          allFemale: "Todas",
          recurring: "Recorrentes",
          single: "Únicas",
        },
        status: {
          inactive: "Inativa",
          scheduled: "Programada",
          inProgress: "Em Andamento",
          suspendedConnection: "Suspensa por conexão - retomada manual",
          cancelled: "Cancelada",
          finished: "Finalizada",
        },
        operationalStatus: {
          paused: "Pausada",
          scheduled: "Programada",
          cancelled: "Cancelada",
          failed: "Falhou",
          suspendedManual: "Suspensa - aguarda retomada manual",
          completed: "Concluída",
          running: "Em execução",
          pending: "Pendente",
        },
        recurrence: {
          minutely: "Por Minuto",
          hourly: "Por Hora",
          daily: "Diário",
          weekly: "Semanal",
          biweekly: "Quinzenal",
          monthly: "Mensal",
          yearly: "Anual",
          executions: "{{count}} execuções",
          single: "Única",
          finished: "Recorrência finalizada",
        },
        tooltips: {
          recurringCampaign: "Campanha Recorrente",
          suspendedConnection: "A campanha ficou suspensa por queda/desconexão e não volta sozinha após reconectar.",
          pauseCampaign: "Pausar Campanha",
          resumeCampaign: "Retomar Campanha",
          resumeCampaignManually: "Retomar Campanha Manualmente",
          stopRecurrence: "Interromper Recorrência",
          report: "Relatório",
        },
        fallbacks: {
          removedList: "Lista removida",
          notDefined: "Não definida",
          removedWhatsapp: "WhatsApp removido",
          noSchedule: "Sem agendamento",
          notCompleted: "Não concluída",
        },
        pagination: {
          total: "Total: {{count}} campanhas",
          rowsPerPage: "Linhas por página:",
          displayedRows: "{{from}}-{{to}} de {{count}}",
          moreThan: "mais de {{to}}",
        },
      },
              campaignReport: {
          title: "Relatório de",
          inactive: "Inativa",
          scheduled: "Programada",
          process: "Em Andamento",
          suspendedConnection: "Suspensa por conexão - retomada manual",
          cancelled: "Cancelada",
          finished: "Finalizada",
          campaign: "Campanha",
          validContacts: "Contatos Válidos",
          confirmationsRequested: "Confirmações Solicitadas",
          confirmations: "Confirmações",
          deliver: "Entregues",
          connection: "Conexão",
          contactLists: "Lista de Contatos",
          schedule: "Agendamento",
          conclusion: "Conclusão",
          fetchError: "Erro ao buscar dados do relatório",
          backButton: "Voltar",
          toasts: {
            noPermissionRedirect: "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.",
            shippingLoadError: "Erro ao carregar dados de envio",
          },
          shippingStatus: {
            delivered: "Entregue",
            processing: "Processando",
            pending: "Pendente",
            sent: "Enviado",
            read: "Lido",
            played: "Reproduzido",
            failedRetryable: "Falhou, tentando novamente",
            failed: "Falhou",
            cancelled: "Cancelado",
          },
          whatsappConnection: "Conexão WhatsApp",
          usedTag: "Tag Utilizada",
          notSpecified: "Não especificado",
          notScheduled: "Não agendado",
          notCompleted: "Não concluído",
          messageDetails: "Detalhes das Mensagens",
          exportExcel: "Exportar Excel",
          messagesTableAria: "tabela de mensagens",
          loading: "Carregando...",
          noMessagesFound: "Nenhuma mensagem encontrada",
          table: {
            recipient: "Destinatário",
            message: "Mensagem",
            sentAt: "Enviado em",
            deliveredAt: "Entregue em",
            attemptsNextRetry: "Tentativas / Próximo Reenvio",
          },
        },
      announcements: {
        title: "Informativos",
        searchPlaceholder: "Pesquisa",
        active: "Ativo",
        inactive: "Inativo",
        buttons: {
          add: "Novo Informativo",
          contactLists: "Listas de Informativos",
        },
        table: {
          priority: "Prioridade",
          title: "Title",
          text: "Texto",
          mediaName: "Arquivo",
          status: "Status",
          actions: "Ações",
        },
        dialog: {
          edit: "Edição de Informativo",
          add: "Novo Informativo",
          update: "Editar Informativo",
          readonly: "Apenas Visualização",
          form: {
            priority: "Prioridade",
            title: "Title",
            text: "Texto",
            mediaPath: "Arquivo",
            status: "Status",
            high: "Alta",
            medium: "Média",
            low: "Baixa",
            active: "Ativo",
            inactive: "Inativo",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          deleted: "Registro excluído",
        },
      },
      campaignsConfig: {
        title: "Configurações de Campanhas",
      },
      queues: {
        title: "Filas & Chatbot",
        table: {
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de saudação",
          orderQueue: "Ordenação da fila (bot)",
          actions: "Ações",
          ID: "ID",
        },
        buttons: {
          add: "Adicionar fila",
        },
        toasts: {
          success: "Fila salva com sucesso",
          deleted: "Fila exclu[ida com sucesso",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! Os atendimentos dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
        },
      },
      queue: {
        queueData: "Dados",
      },
      queueSelect: {
        inputLabel: "Filas",
        inputLabelRO: "Filas somente leitura",
        withoutQueue: "Sem fila",
      },
      reports: {
        title: "Relatórios de Atendimentos",
        startDate: "Data Inicial",
        endDate: "Data final",
        table: {
          id: "Ticket",
          user: "Usuário",
          dateOpen: "Data Abertura",
          dateClose: "Data Fechamento",
          NPS: "NPS",
          status: "Status",
          whatsapp: "Conexão",
          queue: "Fila",
          actions: "Ações",
          lastMessage: "Últ. Mensagem",
          contact: "Cliente",
          supportTime: "Tempo de Atendimento",
        },
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Apenas Avaliados",
        },
        searchPlaceholder: "Pesquisar...",
      },
      queueIntegration: {
        title: "Integrações",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          lastUpdate: "Ultima atualização",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Projeto",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! e será removida das filas e conexões vinculadas",
        },
      },
      users: {
        title: "Usuários",
        table: {
          status: "Status",
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          startWork: "Inicio de trabalho",
          endWork: "Fim de trabalho",
          actions: "Ações",
          ID: "ID",
        },
        buttons: {
          add: "Adicionar usuário",
        },
        toasts: {
          deleted: "Usuário excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usuário serão perdidos. Os atendimento abertos deste usuário serão movidos para a fila.",
        },
      },
      compaies: {
        title: "Empresas",
        table: {
          ID: "ID",
          status: "Ativo",
          name: "Nome",
          email: "Email",
          password: "Senha",
          phone: "Telefone",
          plan: "Plano",
          active: "Ativo",
          numberAttendants: "Atendentes",
          numberConections: "Conexões",
          value: "Valor",
          namePlan: "Nome Plano",
          numberQueues: "Filas",
          useCampaigns: "Campanhas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Chat Interno",
          useSchedules: "Agendamento",
          createdAt: "Criada Em",
          dueDate: "Vencimento",
          lastLogin: "Ult. Login",
          folderSize: "Tamanho da pasta ",
          totalFiles: " Total de arquivos",
          lastUpdate: "Ultimo update",
          actions: "Ações",
          money: "R$",
          yes: "Sim",
          no: "Não",
          document: "CNPJ/CPF",
          recurrence: "Recorrência",
          monthly: "Mensal",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Limpar",
          delete: "Excluir",
          user: "Usuário",
          save: "Salvar",
          generateInvoice: "Gerar Fatura",
        },
        buttons: {
          add: "Adicionar empresa",
        },
        modal: {
          editTitle: "Editar Empresa",
        },
        toasts: {
          deleted: "Empresa excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados da empresa serão perdidos. Os tickets abertos deste usuário serão movidos para a fila.",
        },
      },
      plans: {
        form: {
          name: "Nome",
          users: "Usuários",
          connections: "Conexões",
          campaigns: "Campanhas",
          schedules: "Agendamentos",
          enabled: "Habilitadas",
          disabled: "Desabilitadas",
          clear: "Cancelar",
          delete: "Excluir",
          save: "Salvar",
          yes: "Sim",
          no: "Não",
          money: "R$",
          public: "Público",
          trial: "Trial",
          trialDays: "Dias Trial",
          billingCycle: {
            monthly: "mês",
            quarterly: "trimestre",
            semiannual: "semestre",
            annual: "ano",
            custom: "personalizado",
          },
        },
        modal: {
          editTitle: "Editar Plano",
        },
      },
      helps: {
        title: "Central de Ajuda",
        settings: {
          codeVideo: "Código do Video",
          description: "Descrição",
          clear: "Limpar",
          delete: "Excluir",
          save: "Salvar",
        },
      },
      schedules: {
        title: "Agendamentos",
        date: "Data",
        time: "Hora",
        event: "Evento",
        allDay: "Dia Todo",
        week: "Semana",
        work_week: "Agendamentos",
        day: "Dia",
        month: "Mês",
        previous: "Anterior",
        next: "Próximo",
        yesterday: "Ontem",
        tomorrow: "Amanhã",
        today: "Hoje",
        agenda: "Agenda",
        noEventsInRange: "Não há agendamentos no período.",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir este Agendamento?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          contact: "Contato",
          body: "Mensagem",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          status: "Status",
          actions: "Ações",
        },
        buttons: {
          add: "Novo Agendamento",
        },
        toasts: {
          deleted: "Agendamento excluído com sucesso.",
          sentEditBlocked: "Este agendamento já foi enviado e não pode ser editado.",
          sentDeleteBlocked: "Não é possível excluir um agendamento já enviado.",
          noPermissionRedirect: "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.",
        },
        confirmations: {
          deleteSchedule: "Deseja excluir este agendamento?",
        },
        aria: {
          calendarView: "visualização do calendário",
          monthView: "visualização mensal",
          weekView: "visualização semanal",
          dayView: "visualização diária",
          agendaView: "agenda",
        },
      },
      tags: {
        title: "Tags",
        addColumns: "+ ADICIONAR COLUNAS",
        search: "BUSCAR",
        seeTicket: "VER TICKET",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta Tag?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          id: "ID",
          name: "Nome",
          kanban: "Kanban",
          color: "Cor",
          tickets: "Registros Tags",
          contacts: "Contatos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Tag",
        },
        toasts: {
          deleted: "Tag excluído com sucesso.",
        },
      },

      tagsKanban: {
        title: "Lanes",
        laneDefault: "Em aberto",
        backToKanban: "VOLTAR PARA O KANBAN",

        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta Lane?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          name: "Nome",
          color: "Cor",
          tickets: "Tickets",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Lane",
        },
        toasts: {
          deleted: "Lane excluída com sucesso.",
        },
      },

      files: {
        title: "Lista de arquivos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ação",
        },
        toasts: {
          deleted: "Lista excluída com sucesso!",
          deletedAll: "Todas as listas foram excluídas com sucesso!",
        },
        buttons: {
          add: "Adicionar",
          deleteAll: "Deletar Todos",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteAllTitle: "Deletar Todos",
          deleteMessage: "Tem certeza que deseja deletar esta lista?",
          deleteAllMessage: "Tem certeza que deseja deletar todas as listas?",
        },
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        title: "Configurações",
        toasts: {
          schedulesUpdated: "Horários atualizados com sucesso.",
        },
        tabs: {
          options: "Opções",
          schedules: "Horários",
          finalization: "Finalização do Atendimento",
          plans: "Planos",
          helps: "Ajuda",
          masks: "Máscaras",
          companies: "Empresas",
          whitelabel: "Whitelabel",
          homepage: "Personalização Home",
          about: "Sobre",
        },
        settings: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
          tabs: {
            options: "Opções",
            schedules: "Horários",
            plans: "Planos",
            help: "Ajuda",
          },
          sections: {
            general: "Configurações Gerais",
            generalDescription: "Configure as opções principais do sistema",
            messages: "Mensagens",
            messagesDescription: "Personalize as mensagens enviadas automaticamente",
            lgpd: "LGPD",
            lgpdDescription: "Configurações de privacidade e proteção de dados",
            payments: "Pagamentos",
            paymentsDescription: "Configure métodos de pagamento",
            transcription: "Transcrição",
            transcriptionDescription: "Configurações de transcrição de áudio",
            copyContact: "Configuração de Sigla para Cópia de Contatos",
            copyContactDescription: "Configure como os números de telefone são formatados ao copiar contatos",
          },
          options: {
            disabled: "Desabilitado",
            enabled: "Habilitado",
            updating: "Atualizando...",
            open: "Aberto",
            pending: "Pendente",
            creationCompanyUser: "Criação de Company/Usuário",
            evaluations: "Avaliações",
            officeScheduling: "Agendamento de Expediente",
            queueManagement: "Gerenciamento por Fila",
            companyManagement: "Gerenciamento por Empresa",
            connectionManagement: "Gerenciamento por Conexão",
            sendGreetingAccepted: "Enviar saudação ao aceitar o ticket",
            sendMsgTransfTicket:
              "Enviar mensagem transferência de setor/atendente",
            checkMsgIsGroup: "Ignorar Mensagens de Grupos",
            chatBotType: "Tipo do Bot",
            userRandom: "Escolher atendente aleatório",
            buttons: "Botões",
            acceptCallWhatsapp: "Informar que não aceita ligação no whatsapp?",
            sendSignMessage: "Permite atendente escolher ENVIAR Assinatura",
            sendGreetingMessageOneQueues:
              "Enviar saudação quando houver somente 1 fila",
            sendQueuePosition: "Enviar mensagem com a posição da fila",
            sendFarewellWaitingTicket:
              "Enviar mensagem de despedida no Aguardando",
            acceptAudioMessageContact:
              "Aceita receber audio de todos contatos?",
            enableLGPD: "Habilitar tratamento LGPD",
            requiredTag: "Tag obrigatoria para fechar ticket",
            closeTicketOnTransfer:
              "Fechar ticket ao transferir para outra fila",
            transferredTicketStatus:
              "Status do ticket ao transferir com usuário",
            DirectTicketsToWallets:
              "Mover automaticamente cliente para carteira",
            showNotificationPending:
              "Mostrar notificação para tickets pendentes",
            copyContactPrefix: "Sigla para Cópia de Contatos",
            copyContactPrefixPlaceholder: "Ex: COPIA_",
             removeCountryCode: "Remover código do país",
            removeAreaCode: "Remover código de área (DDD)",
            removeNinthDigit: "Remover nono dígito",
            maskHint: "Digite '@' para inserir máscaras dinâmicas"
          },
          customMessages: {
            sendQueuePositionMessage: "Mensagem de posição na fila",
            AcceptCallWhatsappMessage:
              "Mensagem para informar que não aceita ligações",
            greetingAcceptedMessage: "Mensagem de Saudação ao aceitar ticket",
            transferMessage:
              "Mensagem de transferência - ${queue.name} = fila destino",
          },
          LGPD: {
            title: "LGPD",
            welcome: "Mensagem de boas vindas(LGPD)",
            linkLGPD: "Link da política de privacidade",
            obfuscateMessageDelete: "Ofuscar mensagem apagada",
            alwaysConsent: "Sempre solicitar consentimento",
            obfuscatePhoneUser: "Ofuscar número telefone para usuários",
            enabled: "Habilitado",
            disabled: "Desabilitado",
          },
          masks: {
            title: "Guia de Referência de Máscaras",
            description: "Use máscaras dinâmicas para personalizar suas mensagens. Digite '@' nos campos de mensagem para ver as opções disponíveis.",
            mask: "Máscara",
            description: "Descrição",
            example: "Exemplo",
            howToUse: "Como usar:",
            usageInstructions: "1. Ao editar uma mensagem, digite '@' para abrir o menu de máscaras\n2. Digite parte do nome da máscara ou descrição para filtrar\n3. Clique na máscara desejada ou pressione Enter para selecionar\n4. A máscara será inserida automaticamente no texto\n\nExemplo de mensagem completa:\n\"Olá ${contact.name}! Você foi transferido para a fila ${queue.name} e será atendido por ${user.name}.\""
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Atribuído à:",
          dialogRatingTitle:
            "Deseja deixar uma avaliação de atendimento para o cliente?",
          dialogClosingTitle: "Finalizando o atendimento com o cliente!",
          dialogRatingCancel: "Resolver COM Mensagem de Despedida",
          dialogRatingSuccess: "Resolver e Enviar Avaliação",
          dialogRatingWithoutFarewellMsg: "Resolver SEM Mensagem de Despedida",
          ratingTitle: "Escolha um menu de avaliação",
          notMessage: "Nenhuma mensagem selecionada",
          amount: "Valor de prospecção",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
            rating: "Enviar Avaliação",
            enableIntegration: "Habilitar integração",
            disableIntegration: "Desabilitar integração",
            logTicket: "Logs do Ticket",
            requiredTag: "Você deve atribuir uma tag antes de fechar o ticket.",
            greetingAcceptedMessage:
              "Você deve configurar uma mensagem de saudação ao aceitar o ticket.",
          },
        },
        status: {
          forwarded: "Encaminhada",
          editedAt: "Editada {{time}}",
        },
        deletedMessage: "🚫 Essa mensagem foi apagada",
        deletedMessageByContact: "🚫 Essa mensagem foi apagada pelo contato",
        deletedMessageMarkdown: "🚫 _Mensagem apagada_ ",
        reactions: {
          contactReacted: "{{contact}} reagiu... {{reaction}}",
          youReacted: "Você reagiu... {{reaction}}",
        },
        video: {
          unsupported: "Seu navegador não suporta reprodução de vídeo.",
          loadError: "❌ Erro ao carregar vídeo",
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Digite uma mensagem ou aperte / para respostas rápidas",
        placeholderOpen:
          "Digite uma mensagem ou aperte / para respostas rápidas",
        placeholderClosed:
          "Reabra ou aceite esse ticket para enviar uma mensagem.",
        signMessage: "Assinar",
        privateMessage: "Mensagem Privada",
      },
      contactDrawer: {
        header: "Dados do contato",
        buttons: {
          edit: "Editar contato",
          block: "Bloquear",
          unblock: "Desbloquear",
        },
        extraInfo: "Outras informações",
        toasts: {
          checkTicketsError: "Erro ao verificar tickets existentes",
          startParticipantChatError: "Não foi possível iniciar a conversa com este participante",
          noParticipantsToExport: "Não há participantes para exportar",
          exportSuccess: "Arquivo \"{{fileName}}\" exportado com sucesso!",
          exportError: "Erro ao exportar participantes",
          blocked: "Contato bloqueado",
          unblocked: "Contato desbloqueado",
          updated: "Contato atualizado com sucesso!",
          loadParticipantsError: "Erro ao carregar participantes do grupo",
        },
        empty: {
          images: "Nenhuma imagem encontrada",
          videos: "Nenhum vídeo encontrado",
          audios: "Nenhum áudio encontrado",
          documents: "Nenhum documento encontrado",
          links: "Nenhum link encontrado",
        },
        searchPlaceholder: "Pesquisar nas mensagens...",
        tabs: {
          info: "Informações",
          images: "Imagens",
          videos: "Vídeos",
          audios: "Áudios",
          documents: "Documentos",
          links: "Links",
          participants: "Participantes",
        },
        actions: {
          blockContact: "Bloquear contato",
          unblockContact: "Desbloquear contato",
          export: "Exportar",
          chat: "Conversar",
        },
        warning: {
          possibleLid: "⚠️ Possível erro: Número parece ser LID",
        },
        participants: {
          title: "Participantes do Grupo ({{count}})",
        },
        roles: {
          superAdmin: "Super Admin",
          admin: "Admin",
        },
        fallbacks: {
          otherUser: "Outro usuário",
          noQueue: "Sem fila",
        },
      },
      messageVariablesPicker: {
        label: "Variavéis disponíveis",
        vars: {
          contactFirstName: "Primeiro Nome",
          contactName: "Nome",
          user: "Atendente",
          greeting: "Saudação",
          protocolNumber: "Protocolo",
          date: "Data",
          hour: "Hora",
          ticket_id: "Nº do Chamado",
          queue: "Setor",
          connection: "Conexão",
          scheduledDate: "Data do Agendamento",
        },
      },
      ticketOptionsMenu: {
        schedule: "Agendamento",
        delete: "Deletar",
        transfer: "Transferir",
        registerAppointment: "Observações do Contato",
        resolveWithNoFarewell: "Finalizar sem despedida",
        acceptAudioMessage: "Aceitar áudios do contato?",
        appointmentsModal: {
          title: "Observações do Ticket",
          textarea: "Observação",
          placeholder: "Insira aqui a informação que deseja registrar",
        },
        confirmationModal: {
          title: "Deletar o ticket do contato",
          titleFrom: "do contato ",
          message:
            "Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageInput: {
        tooltip: {
          signature: "Habilitar/Desabilitar Assinatura",
          privateMessage: "Habilitar/Desabilitar Mensagem Privada",
          meet: "Enviar link para videoconferencia",
          triggerFlow: "Disparar Fluxo",
          requiredTemplate: "Enviar Template Meta (Obrigatório)",
          pendingModeSwitch: "Alternar: mensagem normal / interna",
          ticketNote: "Observação do ticket",
        },
        type: {
          imageVideo: "Fotos e vídeos",
          cam: "Câmera",
          contact: "Contato",
          meet: "Vídeo chamada",
          template: "Template Meta",
          document: "Documento",
          signature: "Assinatura",
        },
        format: {
          bold: "Negrito",
          italic: "Itálico",
          strikethrough: "Tachado",
          code: "Código",
          numberedList: "Lista Numerada",
          bulletList: "Lista com Marcadores",
          quote: "Citação",
          clear: "Limpar Formatação",
        },
        pendingAlert: {
          title: "Ticket Aguardando:",
          description: "Use mensagem normal para aceitar e responder, mensagem interna ou observação para notas internas.",
        },
        flowProcessingAlert: {
          title: "Fluxo em Execução:",
          description: "Campo de mensagem temporariamente desabilitado.",
        },
        templateRequiredAlert: {
          title: "Janela de 24h Expirada:",
          description: "Para retomar a conversa, envie um template Meta primeiro.",
        },
        placeholder: {
          internalMessage: "Mensagem interna (não envia ao cliente)",
          ticketNote: "Observação do ticket (anotação interna)",
        },
        quickAnswers: {
          keyboardHint: "📋 {{count}} respostas • use ↑↓ para navegar",
          scrollHint: "{{count}} respostas • role para ver mais",
        },
      },
      messageOptionsMenu: {
        delete: "Deletar",
        reply: "Responder",
        edit: "Editar",
        forward: "Encaminhar",
        toForward: "Encaminhar",
        cancelForward: "Cancelar",
        talkTo: "Conversar Com",
        copy: "Copiar",
        react: "Reagir",
        favorite: "Favoritar",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta ação não pode ser revertida.",
        },
      },
      invoices: {
        table: {
          invoices: "Faturas",
          details: "Detalhes",
          users: "Usuários",
          connections: "Conexões",
          queue: "Filas",
          value: "Valor",
          expirationDate: "Data Venc.",
          action: "Ação",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_CHECK_CONTACT:
          "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS:
          "Erro de autenticação. Por favor, tente novamente.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_SENDING_WAPP_REACTION:
          "Erro ao enviar reação do WhatsApp. Verifique a página de conexões.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_MESSAGE_NOT_FOUND: "Mensagem não encontrada.",
        ERR_INVALID_MESSAGE_DATA: "Erro ao processar dados da mensagem.",
        ERR_MESSAGE_KEY_NOT_FOUND: "Chave da mensagem não encontrada.",
        ERR_CONTACT_NOT_FOUND: "Contato não encontrado.",
        ERR_TICKET_NOT_FOUND: "Ticket não encontrado.",
        ERR_EMOJI_REQUIRED: "Emoji é obrigatório.",
        ERR_REACTIONS_ONLY_WHATSAPP: "Reações só estão disponíveis para WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete aberto para este contato.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
          "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor já está em uso, escolha outra.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudação é obrigatório quando há mais de uma fila.",
        ERR_OUT_OF_HOURS: "Fora do Horário de Expediente!",
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Método:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization:
          "Authorization Bearer (token registrado) e Content-Type (application/json)",
        body: "Body:",
        fieldNumber: '"number": "558599999999"',
        fieldBody: '"body": "Mensagem"',
        fieldUserId: '"userId": ID do usuário ou ""',
        fieldQueueId: '"queueId": ID da Fila ou ""',
        fieldSendSignature: '"sendSignature": Assinar mensagem - true/false',
        fieldCloseTicket: '"closeTicket": Encerrar o ticket - true/false',
        singMessage: "Assinar mensagem - true/false",
        closeTicket: "Encerrar o ticket - true/false",
        testSend: "Teste de envio",
      },
      recurrenceSection: {
        title: "Recorrência",
        description:
          "Você pode escolher enviar a mensagem de forma recorrente e escolher o intervalo. Caso seja uma mensagem a ser enviada uma única vez, não altere nada nesta seção.",
        labelInterval: "Intervalo",
        intervalFilterValue: "Valor do Intervalo",
        sendAsManyTimes: " Enviar quantas vezes",
        shipNormallyOnNonbusinessDays: " Enviar normalmente em dias não úteis",
        sendOneBusinessDayBefore: "Enviar um dia útil antes",
        sendOneBusinessDayLater: "Enviar um dia útil depois",
        options: {
          days: "Dias",
          weeks: "Semanas",
          months: "Meses",
          minutes: "Minutos",
        },
      },
      servicePanel: {
        allowRealTime: "Painel de Atendimentos",
      },
      financial: {
        invoices: "Faturas",
        details: "Detalhes",
        users: "Usuários",
        connections: "Conexões",
        queues: "Filas",
        value: "Valor",
        expirationDate: "Data Venc.",
        status: "Status",
        action: "Ação",
      },
      statusFilter: {
        statusFilter: "Filtro por Status",
      },
      momentsUser: {
        services: "Atendimentos:",
        pending: "Pendentes",
        noqueue: "SEM FILA",
      },
      campaignsPhrase: {
        campaignsFlow: "Fluxo de Campanhas",
        campaigns: "Campanhas",
        name: "Nome",
        status: "Status",
        newCampaignWithFlowByPhrase: "Nova campanha com fluxo por frase",
        editCampaignWithFlowByPhrase: "Editar campanha com fluxo por frase",
        phraseTriggerName: "Nome do disparo por frase",
        chooseAStream: "Escolha um fluxo",
        whichPhraseTriggersTheFlow: " Qual frase dispara o fluxo?",
        selectAConnection: " Selecione uma Conexão",
        chooseAStream: " Escolha um fluxo",
        status: " Status",
        cancel: "CANCELAR",
        createCampaign: "CRIAR CAMPANHA ",
        saveCampaign: "Salvar Campanha",
        toasts: {
          loadFlowsError: "Erro ao carregar fluxos",
          loadConnectionsError: "Erro ao carregar conexões",
          loadCampaignError: "Erro ao carregar dados da campanha",
          requiredFields: "Por favor, preencha todos os campos obrigatórios",
          flowNotFound: "Fluxo selecionado não encontrado",
          updated: "Campanha atualizada com sucesso!",
          created: "Campanha criada com sucesso!",
          saveError: "Erro ao salvar campanha",
        },
        form: {
          campaignName: "Nome da campanha",
          nameRequired: "Nome é obrigatório",
          selectFlow: "Selecione um fluxo",
          flowRequired: "Fluxo é obrigatório",
          multiple: "(Múltiplas)",
          whatsappConnections: "Conexões WhatsApp",
          connectionRequired: "Pelo menos uma conexão deve ser selecionada",
          selectedConnections: "{{count}} conexão(ões) selecionada(s):",
          selectedConnectionsDescription: "A campanha será executada quando qualquer uma dessas conexões receber mensagens que façam match com as frases configuradas.",
          phrasesTitle: "Frases/Palavras que disparam o fluxo",
          exactMatchTitle: "Correspondência Exata:",
          exactMatchDescription: "A mensagem deve ser idêntica à frase configurada.",
          partialMatchTitle: "Correspondência Parcial:",
          partialMatchDescription: "A frase pode estar contida em qualquer parte da mensagem.",
          phraseLabel: "Frase {{count}}",
          phrasePlaceholder: "Digite a frase ou palavra-chave",
          phraseRequired: "Frase é obrigatória",
          type: "Tipo",
          exact: "Exata",
          partial: "Parcial",
          addPhrase: "Adicionar Frase",
        },
      },
      whatsappModalRel: {
        form: {
          isOficial: "Relatório do Atendimento",
          ticketId: "ID do Ticket",
          client: "Cliente",
          number: "Número",
          agent: "Atendente",
          date: "Data",
          lastMessage: "Última Mensagem",
          fullReport: "O relatório completo foi anexado acima",
          resolveAndTriggerIntegration: "Resolver e Disparar Integração",
          elementNotFoundForExport: "Elemento não encontrado para exportar.",
          reportFilename: "relatório_atendimento",
        },
      },
      chatList: {
        noMessages: "Nenhuma mensagem",
        admin: "Administrador",
        member: "Membro",
        searchChat: "Procurar chat...",
        createNewChat: "Criar novo chat",
        searchUser: "Procurar usuário...",
        noUserFound: "Nenhum usuário encontrado",
        noUserAvailable: "Nenhum usuário disponível",
        cancel: "Cancelar",
        details: "Detalhes",
        deleteChat: "Excluir Conversa",
        deleteChatConfirm: "Esta ação não pode ser revertida, confirmar?",
        detailsTitle: "Detalhes",
        edit: "Editar",
        delete: "Excluir",
        now: "agora",
        minutesAgo: "{{count}}m atrás",
        hoursAgo: "{{count}}h atrás",
      },
      chatMessages: {
        deleted: "Esta mensagem foi apagada",
        deletedAdmin: "Mensagem apagada - visível apenas para administradores",
        reply: "Responder",
        edit: "Editar",
        delete: "Excluir",
        forward: "Encaminhar",
        editMessage: "Editar Mensagem",
        save: "Salvar",
        cancel: "Cancelar",
        deleteMessage: "Deletar Mensagem",
        deleteMessageConfirm: "Tem certeza que deseja deletar esta mensagem?",
        forwardMessage: "Encaminhar Mensagem",
        selectChat: "Selecione o chat",
        doubleClickToReply: "Clique duas vezes para responder",
        edited: "(editada)",
        forwarded: "(encaminhada)",
        typeMessage: "Digite uma mensagem...",
        send: "Enviar",
        noMessages: "Nenhuma mensagem",
        loading: "Carregando...",
        replyingTo: "Respondendo a",
        clickToGoToOriginal: "Clique para ir até a mensagem original",
      },
      chatPopover: {
        reply: "Responder",
        edit: "Editar",
        delete: "Excluir",
        forward: "Encaminhar",
        cancel: "Cancelar",
        confirmDelete: "Confirmar Exclusão",
        confirm: "Confirmar",
        deleteMessage: "Tem certeza que deseja excluir esta mensagem?",
        editMessage: "Editar Mensagem",
        save: "Salvar",
        forwardMessage: "Encaminhar Mensagem",
        selectChat: "Selecione o chat",
        noChats: "Nenhum chat disponível",
      },
      chatIndex: {
        chats: "Chats",
        groups: "Grupos",
        new: "Novo",
        messages: "Mensagens",
        search: "Buscar...",
        noChats: "Nenhum chat encontrado",
        noGroups: "Nenhum grupo encontrado",
        noMessages: "Nenhuma mensagem",
        loading: "Carregando...",
        error: "Erro ao carregar dados",
        addGroupPhoto: "Adicionar Foto do Grupo",
        changeGroupPhoto: "Alterar Foto do Grupo",
        groupName: "Nome do Grupo",
        groupDescription: "Descrição do Grupo",
        save: "Salvar",
        cancel: "Cancelar",
        createGroup: "Criar Grupo",
        editGroup: "Editar Grupo",
        deleteGroup: "Deletar Grupo",
        deleteGroupConfirm: "Tem certeza que deseja deletar este grupo?",
        edit: "Editar",
        delete: "Excluir",
        details: "Detalhes",
        groupDetails: "Detalhes do Grupo",
        title: "Título",
        description: "Descrição",
        modal: {
          title: "Criar grupo",
          name: "Nome do grupo",
          description: "Descrição do grupo",
          create: "Criar",
          cancel: "Cancelar",
          save: "Salvar",
          edit: "Editar",
        },
        modal: {
          title: "Criar Grupo",
          editTitle: "Editar Grupo",
          save: "Salvar",
          cancel: "Cancelar",
        },
      },
      salesReport: {
        title: "Relatório de Vendas",
        toasts: {
          selectPeriod: "Por favor, selecione o período",
        },
        filters: {
          startDate: "Data Inicial",
          endDate: "Data Final",
          agent: "Atendente",
          noSaleReason: "Motivo da Não Venda",
          finishReason: "Motivo da Finalização",
        },
        buttons: {
          generate: "Gerar Relatório",
          generating: "Gerando...",
        },
        stats: {
          totalSales: "Total de Vendas",
          totalSalesValue: "Valor Total de Vendas",
          noSales: "Não Vendas",
          averageTicketsByAgent: "Média de Tickets por Atendente",
        },
        sections: {
          noSaleReasons: "Motivos de Não Venda",
          finishedTickets: "Tickets Finalizados",
          agentPerformance: "Desempenho por Atendente",
        },
        table: {
          agent: "Atendente",
          date: "Data",
          saleValue: "Valor da Venda",
          noSaleReason: "Motivo da Não Venda",
          finishReason: "Motivo da Finalização",
          totalSales: "Total de Vendas",
          totalSalesValue: "Valor Total de Vendas",
          noSales: "Não Vendas",
          totalTickets: "Total de Tickets",
          averageTickets: "Média de Tickets",
        },
      },
      home: {
        themeToggle: "Alternar tema",
        aria: {
          openMenu: "Abrir menu",
          dashboardMockup: "Mockup do dashboard",
        },
        nav: {
          features: "Recursos",
          integrations: "Integrações",
          plans: "Planos",
          contact: "Contato",
          login: "Entrar",
          startNow: "Começar Agora",
        },
        hero: {
          badge: "SaaS Omnichannel para Atendimento e Vendas",
          title: "Automatize seu atendimento e escale suas vendas com o TicketWhats",
          description: "Centralize WhatsApp, Instagram e Facebook em uma plataforma moderna com IA, campanhas inteligentes e automações avançadas.",
          startFree: "Começar Gratuitamente",
          viewDemo: "Ver Demonstração",
        },
        stats: {
          uptime: "Uptime",
          messages: "Mensagens",
          support: "Suporte",
          integrations: "Integrações",
        },
        dashboard: {
          title: "TicketWhats Dashboard",
          activeTickets: "Tickets ativos",
          campaignsToday: "Campanhas hoje",
          customerMessage: "Cliente: Olá, preciso de suporte",
          botMessage: "Bot IA: Já te conectei ao setor ideal.",
          agentMessage: "Atendente: Perfeito, vou ajudar agora.",
        },
        floating: {
          conversion: "+42% Conversão",
          aiActive: "IA Ativa",
          apiOnline: "API Online",
        },
        features: {
          title: "Recursos para times de alta performance",
          description: "Uma stack completa para atendimento, automação e crescimento com experiência premium.",
          empty: "Nenhum recurso cadastrado ainda. Configure os recursos dos planos no painel administrativo.",
        },
        integrations: {
          title: "Integrações que aceleram sua operação",
          description: "Conecte seus canais, automações e dados sem fricção.",
          empty: "Nenhuma integração cadastrada ainda. Exibindo integrações padrão.",
        },
        ai: {
          title: "Automação com Inteligência Artificial",
          description: "Respostas automáticas, roteamento inteligente, campanhas com contexto e atendimento híbrido para aumentar eficiência sem perder qualidade.",
          items: {
            contextReplies: "Respostas rápidas com contexto do cliente",
            priorityRouting: "Triagem e distribuição automática por prioridade",
            smartWorkflows: "Workflows inteligentes com fallback humano",
            realtimeInsights: "Insights operacionais com métricas em tempo real",
          },
          panelTitle: "Assistente IA",
          sampleUser: "Cliente: Quero saber sobre o plano Business",
          sampleBotOne: "IA: Posso te mostrar preço, recursos e agendar uma demo agora.",
          sampleBotTwo: "IA: Deseja receber a proposta por WhatsApp ou e-mail?",
        },
        pricing: {
          title: "Planos para cada estágio de crescimento",
          description: "Escolha o plano ideal e evolua sem trocar de plataforma.",
          loading: "Carregando planos...",
          featured: "Mais Escolhido",
          empty: "Nenhum plano público ativo encontrado no banco de dados.",
        },
        cta: {
          title: "Pronto para transformar seu atendimento?",
          description: "Ative o TicketWhats e opere com mais velocidade, inteligência e previsibilidade.",
          viewPlatform: "Ver Plataforma",
        },
        footer: {
          description: "Plataforma premium para atendimento omnichannel, automação e crescimento de receita.",
          product: "Produto",
          company: "Empresa",
          support: "Suporte",
          createAccount: "Criar conta",
          docs: "Documentação",
          api: "API",
          terms: "Termos",
          copyright: "© {{year}} TicketWhats. Todos os direitos reservados.",
        },
      },
      messageModal: {
        attachedFile: "Arquivo anexado: {{fileName}}",
        form: {
          name: "Nome",
          intervalValue: "Valor do Intervalo",
          sendHowManyTimes: "Enviar quantas vezes",
          showUser: "Mostrar Usuário",
          createTicket: "Criar Ticket",
        },
        placeholders: {
          connection: "Conexão",
          contacts: "Contatos",
          users: "Usuários",
        },
        options: {
          sendNormallyOnNonBusinessDays: "Enviar normalmente em dias não úteis",
          sendOneBusinessDayBefore: "Enviar um dia útil antes",
          sendOneBusinessDayAfter: "Enviar um dia útil depois",
        },
      },
      flowBuilderInputModal: {
        question: {
          title: "Pergunta",
          tooltip: ["A pergunta que será enviada ao usuário. Você pode incluir variáveis usando $", "{nomeVariavel}"].join(""),
          label: "Digite a pergunta",
          placeholder: ["Ex: Olá $", "{nome}, qual é a sua idade?"].join(""),
        },
        variables: {
          available: "Variáveis disponíveis (clique para inserir):",
        },
        variableName: {
          title: "Nome da variável",
          tooltip: "Nome da variável onde a resposta será armazenada. Não use espaços ou caracteres especiais.",
          label: "Nome da variável",
          placeholder: "Ex: idade_cliente",
          helper: "A resposta do usuário será armazenada nesta variável",
        },
        howItWorks: {
          title: "Como funciona",
          description: "Este nó enviará a pergunta ao usuário e aguardará uma resposta. Quando o usuário responder, o valor será armazenado na variável especificada e o fluxo continuará para o próximo nó.",
        },
      },
      helpsManager: {
        form: {
          title: "Título",
        },
        table: {
          aria: "tabela de helps",
          title: "Título",
          video: "Video",
        },
        toasts: {
          loadError: "Não foi possível carregar a lista de registros",
          operationError: "Não foi possível realizar a operação. Verifique se já existe uma ajuda com o mesmo nome ou se os campos foram preenchidos corretamente",
          deleteError: "Não foi possível realizar a operação",
        },
        confirmation: {
          deleteTitle: "Exclusão de Registro",
          deleteMessage: "Deseja realmente excluir esse registro?",
        },
      },
      ticketsAdvanced: {
        buttons: {
          selectTicket: "Selecionar Ticket",
        },
        tabs: {
          ticket: "Ticket",
          attendances: "Atendimentos",
        },
      },
      flowBuilder: {
        title: "Fluxos de Conversa ({{count}})",
        searchPlaceholder: "Buscar fluxos...",
        toasts: {
          activated: "Fluxo ativado com sucesso",
          deactivated: "Fluxo desativado com sucesso",
          deleted: "Fluxo excluído com sucesso",
          duplicated: "Fluxo duplicado com sucesso",
          selectZip: "Por favor, selecione um arquivo ZIP (.zip)",
          imported: "Fluxo importado com sucesso",
        },
        editor: {
          title: "Editor de Fluxos",
          addNodes: "Adicionar Nós",
          saveFlow: "Salvar Fluxo",
          toasts: {
            saved: "Fluxo salvo com sucesso",
            saveError: "Erro ao salvar o fluxo",
          },
        },
      },
      floup: {
        title: "Follow UP - Templates de Fluxo",
        stepsCount: "{{count}} passos",
        buttons: {
          newTemplate: "Novo Template",
          duplicate: "Duplicar",
          saveTemplate: "Salvar Template",
          addStep: "Adicionar Passo",
        },
        dialog: {
          editTitle: "Editar Template",
          newTitle: "Novo Template",
        },
        sections: {
          basicInfo: "Informações Básicas",
          triggerCondition: "Condição para Acionamento",
          stopControls: "Controles de Parada do Fluxo",
          flowSteps: "Passos do Fluxo",
        },
        descriptions: {
          triggerCondition: "Defina quando este Follow UP deve ser ativado. Uma vez ativado, todos os passos serão executados sequencialmente, até que as condições de parada sejam atendidas.",
        },
        form: {
          templateName: "Nome do Template",
          templateType: "Tipo do Template",
          description: "Descrição",
          condition: "Condição",
          selectQueue: "Selecionar fila",
          selectTag: "Selecionar tag",
          conditionDescription: "Descrição da condição",
          conditionPlaceholder: "Ex: Cliente enviou primeira mensagem",
        },
        templateTypes: {
          client: "Cliente",
          lead: "Lead",
          custom: "Personalizado",
        },
        conditions: {
          queue: "Fila do sistema",
          tag: "Tag do sistema",
          firstClientInteraction: "Primeira interação do cliente",
          firstAttendantInteraction: "Primeira interação do atendente",
        },
        delete: {
          title: "Confirmar Exclusão",
          message: "Tem certeza que deseja deletar o Follow UP",
          warning: "Esta ação não pode ser desfeita e todas as mídias associadas serão excluídas permanentemente.",
        },
        alerts: {
          saveError: "Erro ao salvar o Follow UP. Verifique o console para mais detalhes.",
          deleteError: "Erro ao deletar o Follow UP. Verifique o console para mais detalhes.",
        },
      },
whitelabel: {
        primaryColorLight: "Cor Primária (Tema Claro)",
        primaryColorDark: "Cor Primária (Tema Escuro)",
        secondaryColorLight: "Cor Secundária (Tema Claro)",
        secondaryColorDark: "Cor Secundária (Tema Escuro)",
        useGradient: "Usar Degradê",
        useGradientDescription: "Ativar efeito degradê nos elementos visuais",
        appName: "Nome da Aplicação",
        logoLight: "Logo (Tema Claro)",
        logoDark: "Logo (Tema Escuro)",
        favicon: "Favicon",
        backgroundLight: "Imagem de Fundo (Tema Claro)",
        backgroundDark: "Imagem de Fundo (Tema Escuro)",
        preview: "Visualizar",
        delete: "Excluir",
        upload: "Enviar",
        availableLanguages: "Idiomas Disponíveis",
        atLeastOneLanguage: "Pelo menos um idioma deve estar habilitado",

        sections: {
          general: "Configurações Gerais",
          generalDescription: "Configure o nome e informações básicas da aplicação",
          colors: "Cores e Temas",
          colorsDescription: "Personalize as cores primárias e secundárias para temas claro e escuro",
          logos: "Logos e Imagens",
          logosDescription: "Carregue os logos e imagens de fundo da aplicação",
          languages: "Idiomas Disponíveis",
          languagesDescription: "Selecione quais idiomas estarão disponíveis no sistema"
        }
      },
    },
  },
};

const mergeTranslations = (target, source) => {
  Object.keys(source).forEach((key) => {
    if (
      source[key] &&
      typeof source[key] === "object" &&
      !Array.isArray(source[key]) &&
      target[key] &&
      typeof target[key] === "object" &&
      !Array.isArray(target[key])
    ) {
      mergeTranslations(target[key], source[key]);
      return;
    }
    target[key] = source[key];
  });
};

mergeTranslations(messages.pt.translations, {
  common: {
    note: "Nota",
    noData: "Sem dados",
    buttons: {
      search: "Buscar",
      loadMore: "Carregar mais...",
    },
    status: {
      error: "Erro",
      online: "Online",
      offline: "Offline",
      connected: "Conectado",
      disconnected: "Desconectado",
    },
    loading: {
      searching: "Pesquisando...",
    },
  },
  connections: {
    contactsImport: {
      title: "Importar Contatos do WhatsApp?",
      message: "Encontramos {{count}} contatos no WhatsApp. Deseja importá-los para o sistema?",
      note: "A importação pode levar alguns minutos dependendo da quantidade de contatos. Você pode acompanhar o progresso na página de Contatos.",
      later: "Agora Não",
      confirm: "Sim, Importar",
    },
    transfer: {
      title: "Transferência de Tickets",
      source: "Origem",
      target: "Destino",
      descriptionStart: "Para transferir os tickets, selecione a conexão de",
      descriptionMiddle: "(de onde os tickets serão movidos) e a conexão de",
      descriptionEnd: "(para onde os tickets serão transferidos). Todos os atendimentos ativos da conexão de origem serão movidos para a conexão de destino.",
    },
    table: {
      channel: "Canal",
    },
    aria: {
      syncTemplates: "Sincronizar templates",
      copyWebhook: "Copiar webhook",
    },
  },
  contacts: {
    group: "Grupo",
    importFileTitle: "Importar contatos de arquivo",
    bulk: {
      selectContactAria: "Selecionar contato {{name}}",
    },
  },
  signup: {
    document: {
      label: "CPF ou CNPJ",
      helper: "Digite CPF (11 dígitos) ou CNPJ (14 dígitos)",
      cpfValid: "CPF válido!",
      cpfInvalid: "CPF inválido!",
      cnpjValidCompanyFilled: "CNPJ válido! Nome da empresa preenchido automaticamente.",
      invalidOrNotFound: "Documento inválido ou não encontrado na Receita Federal",
      validationError: "Erro ao validar documento. Tente novamente.",
    },
  },
  wallets: {
    notFound: "Carteira não encontrada",
  },
  invoices: {
    table: {
      status: "Status",
    },
  },
  financial: {
    attention: "Atenção",
    expiredSubscription: "Sua assinatura está vencida. Entre em contato com o suporte para regularizar sua situação.",
  },
  helps: {
    youtubePlayerTitle: "Player de vídeo do YouTube",
  },
  tickets: {
    globalSearch: {
      title: "Pesquisa Global no atendimento",
      results: "{{count}} resultado(s)",
      minChars: "Digite pelo menos 2 caracteres para pesquisar em contatos, tickets e mensagens.",
      noResults: "Nenhum resultado encontrado para essa busca.",
      placeholder: "Pesquisar em contatos, tickets e mensagens",
    },
    search: {
      filterAria: "Filtrar",
    },
  },
  newTicketModal: {
    newAttendance: "Novo Atendimento",
    attendanceSector: "Setor de Atendimento",
    sendChannel: "Canal de Envio",
    selectSector: "Selecione o setor...",
    selectConnection: "Selecione a conexão...",
    otherUser: "Outro usuário",
    errors: {
      selectQueue: "Selecione uma fila",
    },
  },
  contactListItemFromContactsModal: {
    title: "Buscar na lista de contatos",
    searchPlaceholder: "Buscar por nome ou número...",
    selectedOne: "contato selecionado",
    selectedMany: "contatos selecionados",
    noContactsFound: "Nenhum contato encontrado",
    noContactsAvailable: "Nenhum contato disponível",
    add: "Adicionar",
    adding: "Adicionando...",
  },
  messageModal: {
    placeholders: {
      tags: "Tags",
    },
  },
  messageInput: {
    audioMessage: "🎧 Mensagem de áudio",
    aria: {
      clearReply: "Limpar resposta",
      sendTemplateRequired: "Enviar template obrigatório",
      emojiPicker: "Abrir seletor de emojis",
      uploadMedias: "Anexar mídias",
      uploadMediaFile: "Anexar foto ou vídeo",
      uploadDocument: "Anexar documento",
      toggleSignature: "Alternar assinatura",
      triggerFlow: "Disparar fluxo",
      pendingModeSwitch: "Alternar modo de atendimento pendente",
      pendingModeNote: "Usar observação do ticket",
      cancelForward: "Cancelar encaminhamento",
      sendMessage: "Enviar mensagem",
      cancelRecording: "Cancelar gravação",
      sendRecordedAudio: "Enviar áudio gravado",
      showRecorder: "Abrir gravador",
      privateMessage: "Alternar mensagem privada",
      scheduleMessage: "Agendar mensagem",
    },
  },
  floupDashboard: {
    title: "Dashboard de Follow UP por Etapas",
    followUp: "Follow UP",
    nextRun: "Próxima",
    recentError: "⚠️ Erro recente",
    step: "Etapa",
    steps: "Etapas",
    contacts: "Contatos",
    channel: "Canal",
    noMessage: "Sem mensagem",
    emptyStepContacts: "Nenhum contato nesta etapa",
    selectFloup: "Selecione um Floup para visualizar as etapas",
    noData: "Nenhum dado encontrado para este Floup",
    noSteps: "Nenhuma etapa encontrada",
  },
});

mergeTranslations(messages.pt.translations, {
  common: {
    yes: "Sim",
    no: "Não",
    words: { and: "e" },
    time: { seconds: "segundos" },
    buttons: {
      previous: "Anterior",
      next: "Próxima",
      save: "Salvar",
      refresh: "Atualizar",
      cancel: "Cancelar",
    },
  },
  globalSearch: {
    title: "Pesquisa Global",
    subtitle: "Encontre contatos, trechos de conversa e tickets em um único lugar.",
    loading: "Pesquisando em contatos, mensagens e tickets...",
    placeholders: {
      all: "Busque em contatos, mensagens e tickets",
      messages: "Busque por palavras, frases ou trechos da conversa",
      tickets: "Busque por ticket, contato, número ou última mensagem",
      contacts: "Busque por nome, número ou e-mail do contato",
    },
    fallbacks: {
      noName: "Sem nome",
      contact: "Contato",
      noContact: "Sem contato",
      noTextMessage: "[mensagem sem texto]",
      noQueue: "Sem fila",
      notAssigned: "Não atribuído",
      noLastMessage: "Sem última mensagem",
    },
    meta: {
      company: "Empresa",
      tickets: "Tickets",
      lastInteraction: "Última interação",
      status: "Status",
      queue: "Fila",
      responsible: "Responsável",
    },
    hints: {
      openConversation: "Clique para abrir a conversa",
      openContact: "Clique para abrir o contato",
      openMessage: "Clique para abrir diretamente na mensagem",
      openTicket: "Clique para abrir o ticket",
    },
    empty: {
      title: "Pesquisa global inteligente",
      minChars: "Digite ao menos 2 caracteres para buscar em toda a base.",
      noGlobalResults: "Nenhum resultado encontrado na pesquisa global.",
      noTabResults: "Nenhum resultado encontrado nesta aba.",
    },
    types: {
      contact: "Contato",
      message: "Mensagem",
      ticket: "Ticket",
    },
    results: {
      combined: "{{count}} resultado(s) combinados nas três categorias",
    },
    pagination: {
      page: "Página",
      results: "{{count}} resultado(s)",
    },
    tabs: {
      all: "Todos",
      contacts: "Contatos",
      messages: "Mensagens",
      tickets: "Tickets",
    },
  },
  campaignsWarmup: {
    title: "Campaign Warmup Control Center",
    subtitle: "Visão operacional densa por conexão, com capacidade, reputação, eventos, histórico e ações administrativas direto na tela principal.",
    toasts: {
      actionSuccess: "Ação executada com sucesso!",
      blockReasonRequired: "Informe o motivo do bloqueio.",
      connectionBlocked: "Conexão bloqueada administrativamente.",
    },
    stages: {
      blocked: "Nível 0 · Bloqueado",
      new: "Nível 1 · Novo",
      initial: "Nível 2 · Inicial",
      moderate: "Nível 3 · Moderado",
      conservative: "Nível 4 · Conservador",
      normal: "Nível 5 · Normal",
      high: "Nível 6 · Alta",
    },
    status: {
      blocked: "Bloqueado",
      awaitingBaseline: "Aguardando baseline",
      healthy: "Saudável",
      attention: "Atenção",
      critical: "Crítico",
      campaignsReleased: "Campanhas liberadas",
    },
    labels: {
      manualBlock: "Bloqueio manual",
      automaticBlock: "Bloqueio automático",
      number: "Número",
      connections: "Conexões",
      sentToday: "Envios hoje",
      blockReason: "Motivo do bloqueio",
    },
    fallbacks: {
      campaign: "Campanha #{{id}}",
    },
    meta: {
      status: "Status",
      lastSend: "Último envio",
      lastStageChange: "Última troca de estágio",
    },
    empty: {
      noData: "Sem dados",
      noStage: "Sem estágio",
      noBaseline: "Sem baseline",
      noOperationalBaseline: "Sem baseline operacional",
      noCampaignBaseline: "Sem baseline de campanha ainda",
      noAction: "Sem ação",
      noRecentHistory: "Sem histórico recente.",
      noActiveCampaigns: "Nenhuma campanha ativa.",
      noCriticalRecommendations: "Nenhuma recomendação crítica no momento.",
      awaitingCampaignData: "Aguardando dados de campanha para gerar recomendações.",
      noConnectionFound: "Nenhuma conexão encontrada",
      noConnectionDescription: "Quando houver conexões com warmup de campanhas, elas aparecerão aqui com visão completa de operação.",
    },
    metrics: {
      healthScore: "Health Score",
      spamRiskScore: "Spam Risk Score",
      dailyLimitVsSent: "Limite diário x enviadas hoje",
      hourlyLimitVsSent: "Limite horário x enviadas na hora",
      deliveryRate: "Delivery Rate",
      readRate: "Read Rate",
      replyRate: "Reply Rate",
      deliveredToday: "Delivered Today",
      readToday: "Read Today",
      repliesToday: "Replies Today",
      positiveReplies: "Replies positivas",
      negativeReplies: "Replies negativas",
      neutralReplies: "Replies neutras",
      optOuts: "Opt-outs",
      averageReplyTime: "Tempo médio de resposta",
      percentConsumed: "{{percent}}% consumido",
      successes: "Sucessos",
      failures: "Falhas",
      invalid: "Inválidos",
      score: "Score",
    },
    sections: {
      connectionCapacity: "Capacidade da conexão",
      reputationVolume: "Reputação e volume",
      dayEvents: "Eventos do dia",
      periodPerformance: "Desempenho por período",
      recommendations: "Recomendações",
      recentHistory: "Histórico recente",
      activeCampaigns: "Campanhas ativas",
      analytics: "Visão analítica",
    },
    tabs: {
      today: "Hoje",
      sevenDays: "7 dias",
      thirtyDays: "30 dias",
    },
    hints: {
      lowerIsBetter: "Quanto menor, melhor",
    },
    alerts: {
      manualBlockActive: "Bloqueio manual ativo",
      automaticBlockActive: "Bloqueio automático ativo",
      blockedUntil: "Bloqueado até {{date}}.",
      noBlockDetails: "Sem detalhes do bloqueio.",
    },
    actions: {
      promote: "Promover",
      regress: "Rebaixar",
      block: "Bloquear",
      unblock: "Desbloquear",
      resetCounters: "Resetar contadores",
      confirmBlock: "Confirmar bloqueio",
    },
    kpis: {
      totalConnections: "Total de conexões",
      monitoredNow: "Monitoradas agora",
      healthy: "Saudáveis",
      highScoreLowRisk: "Score alto e baixo risco",
      atRisk: "Em risco",
      needReview: "Pedem revisão operacional",
      blocked: "Bloqueadas",
      manualOrAutomatic: "Manual ou automático",
      consumedCapacity: "Capacidade consumida",
      averageSpamRisk: "Spam Risk médio",
    },
    analytics: {
      healthy: "Saudáveis",
      blocked: "Bloqueadas",
      summary: "Resumo rápido de saúde, distribuição e consumo para leitura executiva.",
      hide: "Ocultar análises",
      show: "Mostrar análises",
      dailyConsumption: "Consumo diário por conexão",
      operationalHealth: "Saúde operacional",
      stageDistribution: "Distribuição por estágio",
      quickIndicators: "Indicadores rápidos",
    },
    indicators: {
      noConnection: "Nenhuma conexão encontrada para monitorar.",
      withoutBaseline: "{{count}} conexão(ões) ainda não possuem baseline suficiente para avaliação de saúde.",
      risky: "{{count}} conexão(ões) exigem atenção por score de saúde baixo ou risco de spam alto.",
      blocked: "{{count}} conexão(ões) estão bloqueadas e dependem de revisão antes de escalar volume.",
      nearLimit: "{{count}} conexão(ões) já consumiram mais de 80% da capacidade diária.",
      stable: "Operação estável no momento. Nenhum alerta crítico detectado.",
    },
    dialog: {
      blockConnectionTitle: "Bloquear conexão para campanhas",
      blockConnectionDescription: "Informe o motivo do bloqueio administrativo. Essa justificativa ficará registrada para auditoria operacional.",
    },
  },
  callHistoricals: {
    title: "Histórico de Ligações",
    searchPlaceholder: "Pesquisar por nome ou telefone...",
    empty: "Nenhum registro encontrado",
    stats: {
      total: "Total de Ligações",
      rejected: "Ligações Rejeitadas",
      served: "Ligações Atendidas",
      finished: "Ligações Finalizadas",
    },
    columns: {
      name: "Nome",
      phone: "Telefone",
      agent: "Atendente",
      dateTime: "Data/Hora",
      direction: "Direção",
      status: "Status",
      duration: "Duração",
      type: "Tipo",
      recording: "Gravação",
      actions: "Ações",
    },
    status: {
      ended: "Finalizada",
      active: "Ativa",
      ringing: "Tocando",
      busy: "Ocupado",
      noAnswer: "Não Atendida",
      rejected: "Rejeitada",
    },
    direction: {
      outgoing: "Saída",
      incoming: "Entrada",
    },
    fallbacks: {
      receivedCall: "Ligação Recebida",
    },
    tooltips: {
      downloadAudio: "Baixar áudio",
      makeCall: "Fazer ligação",
    },
  },
  campaignsConfig: {
    toasts: {
      noPermissionRedirect: "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.",
      saved: "Configurações salvas",
    },
    sections: {
      intervals: "Intervalos",
    },
  },
  floup: {
    step: {
      title: "Passo {{order}}",
      emptyMessage: "Mensagem vazia",
      attachment: "Anexo",
      message: "Mensagem",
      characterCount: "{{count}}/500 caracteres",
      value: "Valor",
      timeUnit: "Unidade de Tempo",
      sendAfter: "Enviar após {{value}} {{unit}}",
      attachmentLink: "Anexo/Link",
      urlPlaceholder: "Cole a URL aqui",
      removeLink: "Remover link",
      removeMedia: "Remover mídia",
      removeStep: "Remover Passo",
      chooseFile: "Escolher Arquivo",
      videoUnsupported: "Seu navegador não suporta o elemento de vídeo.",
    },
    timeUnits: {
      minutes: "Minutos",
      hours: "Horas",
      days: "Dias",
      weeks: "Semanas",
      months: "Meses",
      years: "Anos",
    },
    mediaTypes: {
      link: "Link",
      upload: "Upload",
    },
    preview: {
      title: "Preview da Mensagem",
      attachmentHint: "Ícone de anexo aparecerá aqui",
    },
    alerts: {
      uploadError: "Erro no upload do arquivo. Verifique o console para mais detalhes.",
    },
    stopConditions: {
      anyMessage: "1. Caso o Contato responder qualquer mensagem",
      keyword: "2. Caso o Contato responder uma Palavra chave",
      keywordLabel: "Palavra chave",
      keywordPlaceholder: "Ex: PARAR, CANCELAR, SAIR",
      ticketClosed: "3. Caso o Ticket for Fechado",
    },
  },
  flowDefault: {
    title: "Fluxo padrão",
    toasts: {
      deleted: "Fluxo excluído com sucesso",
      updated: "Fluxos padrões atualizados",
    },
    deleteConfirmation: "Tem certeza que deseja deletar este fluxo? Todas as integrações relacionados serão perdidos.",
    selectFlowPlaceholder: "Escolha um fluxo",
    welcomeFlow: {
      title: "Fluxo de boas vindas",
      description: "Este fluxo é disparado apenas para novos contatos, pessoas que voce não possui em sua lista de contatos e que mandaram uma mensagem",
    },
    defaultResponseFlow: {
      title: "Fluxo de resposta padrão",
      description: "Resposta Padrão é enviada com qualquer caractere diferente de uma palavra chave. ATENÇÃO! Será disparada se o atendimento ja estiver fechado e passado 6 horas do seu fechamento.",
    },
  },
  subscription: {
    title: "Assinatura",
    licensePeriod: "Período de Licença",
    licenseDueToday: "Sua licença vence em hoje!",
    licenseDueDays: "Sua licença vence em {{days}} dias!",
    billingEmail: "Email de cobrança",
    subscribeNow: "Assine Agora!",
  },
  messagesApi: {
    toasts: {
      noPermissionRedirect: "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.",
      messageSent: "Mensagem enviada com sucesso",
    },
    buttons: {
      send: "Enviar",
    },
    docs: {
      endpoint: "Endpoint",
      method: "Método",
      headers: "Headers",
      registeredToken: "token cadastrado",
      formData: "FormData",
      userIdHint: "ID usuário ou",
      queueIdHint: "ID da fila ou",
      file: "arquivo",
    },
  },
});

mergeTranslations(messages.pt.translations, {
  common: {
    loading: {
      saving: "Salvando...",
    },
    buttons: {
      add: "Adicionar",
      edit: "Editar",
      remove: "Remover",
      close: "Fechar",
      saveChanges: "Salvar alterações",
    },
  },
  flowBuilder: {
    nodes: {
      media: {
        unsupportedHtml5: "Seu navegador não suporta HTML5",
      },
      audio: {
        title: "Áudio",
        recorded: "Gravado na hora",
        sent: "Áudio enviado",
      },
      video: {
        title: "Vídeo",
      },
      message: {
        title: "Mensagem",
      },
      attendant: {
        title: "Atendente",
      },
      removeTag: {
        title: "Remover Tag",
      },
      switchFlow: {
        title: "Trocar Fluxo",
      },
      question: {
        title: "Pergunta",
      },
      interval: {
        title: "Intervalo",
      },
      randomizer: {
        title: "Randomizador",
      },
      tag: {
        title: "Tag",
      },
      menu: {
        title: "Menu",
      },
      ticket: {
        title: "Fila",
      },
      image: {
        title: "Imagem",
      },
      openAi: {
        assistant: "Assistente IA GPT",
      },
      gemini: {
        assistant: "Assistente IA Google",
      },
      input: {
        responseVariable: "Variável para armazenar resposta:",
        valueTooltip: "Valor: {{value}}",
        variableNotDefined: "Variável não definida",
        usingVariables: "Usando variáveis: {{variables}}",
        alwaysAsk: "Sempre perguntar (mesmo se variável já existir)",
      },
      variable: {
        title: "Variável Global",
        name: "Nome da variável",
        value: "Valor",
        helper: "Você pode usar valores estáticos ou referências como " + String.fromCharCode(36) + "{outraVariavel}",
        saved: "Salvo!",
        saveButton: "Salvar variável",
        savedSuccess: "Variável salva com sucesso!",
      },
      httpRequest: {
        presetsTitle: "Webhooks Pré-configurados",
        selectPreset: "Selecionar preset",
        selectPresetPlaceholder: "Escolha uma configuração pronta...",
        systemPreset: "SISTEMA",
        usingPreset: "Usando preset:",
        urlFromPreset: "URL (do preset)",
        urlPlaceholder: "https://api.exemplo.com/webhook",
        urlHelper: "Você pode editar a URL base do preset se necessário",
        method: "Método",
        testRequest: "Testar Requisição",
        apiResponse: "Resposta da API:",
        viewFullResponse: "Ver resposta completa",
        hideAdvanced: "Ocultar avançado",
        showAdvanced: "Mostrar avançado",
        advancedWarning: "Configurações avançadas podem sobrescrever as configurações do preset",
        timeoutMs: "Timeout (ms)",
        queryParams: "Parâmetros de Query",
        key: "Chave",
        value: "Valor",
        addParam: "Adicionar Parâmetro",
        headersJson: "Cabeçalhos (JSON)",
        headersPlaceholder: "{\"Authorization\": \"Bearer token\", \"Custom-Header\": \"XYZ\"}",
        requestBodyJson: "Corpo da requisição (JSON)",
        editRequestBody: "Editar corpo da requisição",
        hideMapping: "Ocultar Variáveis da Resposta",
        mapResponseVariables: "Mapear Variáveis da Resposta",
        mapResponseData: "Mapear dados da resposta para variáveis",
        path: "Caminho",
        pathPlaceholder: "ex: data.user.id",
        variableName: "Nome da variável",
        variablePlaceholder: "ex: userId",
        addVariable: "Adicionar variável",
        usefulTips: "Dicas úteis:",
        apiResponseTip: "• A resposta completa da API é salva automaticamente na variável global",
        variableUsageTip: "Você pode usar " + String.fromCharCode(36) + "{nomeDaVariavel} no URL e corpo da requisição para incluir valores de variáveis.",
        fullApiResponse: "Resposta completa da API",
        toasts: {
          presetError: "Erro ao aplicar configuração do preset",
        },
      },
    },
    modals: {
      singleBlock: {
        addTitle: "Adicionar conteúdo ao fluxo",
        addMenuTitle: "Adicionar menu ao fluxo",
        editTitle: "Editar conteúdo",
        variables: "Variáveis",
        toasts: {
          emptyMessage: "Campos de mensagem vazio!",
          invalidInterval: "Intervalo não pode ser 0 ou maior que 120!",
          contentAdded: "Conteúdo adicionada com sucesso!",
          deleteEmptyCards: "Delete os cards vazios(Imagem, Audio e Video)",
        },
      },
      media: {
        image: "Imagem",
        audio: "Áudio",
        video: "Vídeo",
        text: "Texto",
        interval: "Intervalo",
        document: "Documento",
        message: "Mensagem",
        timeInSeconds: "Tempo em segundos",
        uploadImage: "Enviar imagem",
        uploadAudio: "Enviar áudio",
        uploadVideo: "Enviar vídeo",
        uploadDocument: "Enviar Documento",
        sendAsRecordedAudio: "Enviar como áudio gravado na hora",
        viewDocument: "Visualizar Documento",
        addAudioTitle: "Adicionar áudio ao fluxo",
        editAudioTitle: "Editar áudio",
        addImageTitle: "Adicionar imagem ao fluxo",
        editImageTitle: "Editar imagem",
        addVideoTitle: "Adicionar vídeo ao fluxo",
        editVideoTitle: "Editar vídeo",
        toasts: {
          audioAdded: "Áudio adicionado com sucesso!",
          imageAdded: "Imagem adicionada com sucesso!",
          videoAdded: "Vídeo adicionado com sucesso!",
        },
        errors: {
          fileTooLarge2mb: "Arquivo é muito grande! 2MB máximo",
          fileTooLarge5mb: "Arquivo é muito grande! 5MB máximo",
          fileTooLarge10mb: "Arquivo é muito grande! 10MB máximo",
          fileTooLarge20mb: "Arquivo é muito grande! 20MB máximo",
        },
      },
      randomizer: {
        addTitle: "Adicionar um randomizador ao fluxo",
        editTitle: "Editar randomizador",
        percentageAria: "Percentual",
        errors: {
          addIntervalValue: "Adicione o valor de intervalo",
          maxTimeReached: "Máximo de tempo atingido 120 segundos",
        },
      },
      conditionCompare: {
        newTitle: "Nova Comparação",
        editTitle: "Editar Comparação",
        value1: "Valor 1",
        value2: "Valor 2",
        valueHelper: "Pode ser texto fixo ou variável (ex: " + String.fromCharCode(36) + "{variavel})",
        value1Tooltip: "Este é o valor que será comparado. Pode ser texto fixo ou uma variável.",
        value2Tooltip: "Este é o valor com o qual o primeiro valor será comparado. Pode ser texto fixo ou uma variável.",
        valuePlaceholder: "Digite um valor ou selecione uma variável",
        operator: "Operador de Comparação",
        variableButton: "Variável",
        selectVariable: "Selecionar Variável",
        variableHelp: "Estas são variáveis de exemplo. Configure as variáveis reais no nó de Variável Global ou em outros nós do fluxo.",
        searchVariable: "Buscar variável...",
        configureVariableNode: "(Configure no nó de Variável Global)",
        noVariables: "Nenhuma variável encontrada",
        categories: {
          contact: "Contato",
          message: "Mensagem",
        },
        variables: {
          contactName: "Nome do contato",
          contactEmail: "Email do contato",
          contactPhone: "Telefone do contato",
          lastMessage: "Última mensagem recebida",
          lastContactDate: "Data do último contato",
          apiResponse: "Resposta da última requisição HTTP",
        },
        errors: {
          firstRequired: "O primeiro valor é obrigatório",
          secondRequired: "O segundo valor é obrigatório para este operador",
        },
        operators: {
          equals: "Igual a",
          notEquals: "Diferente de",
          contains: "Contém",
          greaterThan: "Maior que",
          lessThan: "Menor que",
          greaterOrEqual: "Maior ou igual a",
          lessOrEqual: "Menor ou igual a",
          startsWith: "Começa com",
          endsWith: "Termina com",
          isEmpty: "Está vazio",
          isNotEmpty: "Não está vazio",
        },
      },
      openAi: {
        addTitle: "Adicionar OpenAI ao fluxo",
        editTitle: "Editar OpenAI do fluxo",
        basicSettings: "Configurações Básicas - OpenAI",
        apiKey: "API Key OpenAI",
        model: "Modelo OpenAI",
        voiceSettings: "Configurações de Voz (Opcional)",
        responseType: "Tipo de Resposta",
        voiceKey: "Voice Key (Azure)",
        voiceKeyPlaceholder: "Chave do Azure Speech Service",
        voiceRegion: "Voice Region (Azure)",
        voiceRegionPlaceholder: "ex: brazilsouth",
        behaviorTooltip: "Configure como o OpenAI deve se comportar no fluxo",
        validation: {
          voiceKeyRequired: "Voice Key é obrigatória para síntese de voz",
          voiceRegionRequired: "Voice Region é obrigatória para síntese de voz",
        },
      },
      gemini: {
        addTitle: "Adicionar Gemini ao fluxo",
        editTitle: "Editar Gemini do fluxo",
        basicSettings: "Configurações Básicas - Google Gemini",
        apiKey: "API Key Google AI",
        model: "Modelo Gemini",
        behaviorTooltip: "Configure como o Gemini deve se comportar no fluxo",
      },
      ai: {
        assistantName: "Nome do Assistente",
        systemPrompt: "Prompt do Sistema",
        systemPromptPlaceholder: "Descreva como a IA deve se comportar, que informações deve coletar, como deve responder...",
        temperature: "Temperatura",
        temperatureHelper: "0 = conservador, 2 = criativo",
        maxTokens: "Max Tokens",
        maxTokensHelper: "Tamanho máximo da resposta",
        maxMessages: "Max Mensagens",
        maxMessagesHelper: "Histórico de contexto",
        flowBehavior: "Comportamento do Fluxo",
        flowMode: "Modo de Funcionamento",
        permanent: "Permanente",
        endFlowHere: "Encerrar fluxo aqui",
        permanentDescription: "O usuário fica conversando com a IA até pedir transferência ou encerrar",
        temporary: "Temporário",
        returnToFlow: "Volta ao fluxo depois",
        temporaryDescription: "A IA executa uma tarefa específica e depois retorna ao fluxo normal",
        temporarySettings: "⏱️ Configurações do Modo Temporário",
        temporarySettingsDescription: "Configure quando a IA deve parar e retornar ao fluxo",
        maxInteractions: "Máximo de Interações",
        maxInteractionsHelper: "Número máximo de mensagens antes de voltar ao fluxo (0 = ilimitado)",
        timeoutMinutes: "Timeout (minutos)",
        timeoutHelper: "Tempo limite antes de voltar ao fluxo (0 = sem limite)",
        continueKeywords: "Palavras-chave para Continuar Fluxo",
        keywordPlaceholder: "Digite uma palavra-chave",
        continueKeywordsHelper: "Quando o usuário enviar uma dessas palavras, o fluxo continuará automaticamente",
        objective: "Objetivo da IA",
        objectiveHelper: "Descreva o que a IA deve completar (ex: 'Coletar nome, email e telefone')",
        objectivePlaceholder: "Ex: Coletar dados do cliente, Qualificar interesse, Diagnosticar problema...",
        autoComplete: "Auto completar quando atingir objetivo",
        autoCompleteHelper: "A IA analisará automaticamente se completou o objetivo e voltará ao fluxo",
        transferQueueId: "ID da Fila (para transferência)",
        transferQueueIdHelper: "ID da fila para onde transferir se usuário pedir atendente (0 = não transferir)",
        validation: {
          invalidModel: "Modelo inválido",
          objectiveRequired: "Objetivo é obrigatório quando auto completar está ativo",
        },
      },
    },
  },
});

mergeTranslations(messages.pt.translations, {
  common: {
    title: "Título",
    name: "Nome",
    description: "Descrição",
    actions: "Ações",
    settings: { general: "Configurações Gerais" },
    buttons: {
      add: "Adicionar",
      back: "Voltar",
    },
    toasts: {
      operationUpdated: "Operação atualizada com sucesso.",
    },
  },
  settings: {
    components: {
      about: {
        subtitle: "Sistema de Atendimento via WhatsApp",
        systemVersions: "Versões do Sistema",
        checkUpdates: "Verificar atualizações",
        systemStatus: "Status do Sistema",
        refreshInfo: "Atualizar informações",
        online: "Online",
        memoryUsage: "Memória em Uso",
        platform: "Plataforma",
        availableFeatures: "Recursos Disponíveis",
        footer: "Desenvolvido para melhorar o atendimento ao cliente",
        companyId: "Empresa ID",
        user: "Usuário",
        toasts: {
          whatsappUpdated: "Versão do WhatsApp atualizada: {{version}}",
          whatsappAlreadyUpdated: "Versão do WhatsApp já está atualizada",
          adminOnly: "Apenas administradores podem verificar atualizações",
          checkError: "Erro ao verificar atualizações",
        },
        features: {
          multichannel: "Atendimento multicanal via WhatsApp",
          tickets: "Gestão de tickets e filas",
          chatbot: "Chatbot com fluxos automatizados",
          campaigns: "Campanhas e mensagens em massa",
          reports: "Relatórios e dashboards",
          apis: "Integração com APIs externas",
          agents: "Suporte a múltiplos atendentes",
          schedules: "Agendamento de mensagens",
        },
      },
      companyTimezone: {
        title: "Timezone da empresa",
        description: "Regras de expediente, automações e agendamentos usam este timezone como referência.",
        timezone: "Timezone",
        saveTimezone: "Salvar timezone",
        toasts: {
          companyDataError: "Não foi possível carregar os dados completos da empresa.",
          updateSuccess: "Timezone da empresa atualizado com sucesso.",
        },
      },
      finalizacaoAtendimento: {
        title: "Finalização de Atendimento",
        informSaleValue: "Informar valor da venda ao finalizar atendimento",
        informSaleValueHelp: "Quando habilitado, o campo de valor da venda aparecerá no modal de finalização",
        reasonsTitle: "Motivos de Finalização",
        addReason: "Adicionar Motivo",
        editReason: "Editar Motivo",
        reasonName: "Nome do Motivo",
        reasonDescription: "Descrição (opcional)",
        noDescription: "Sem descrição",
        emptyReasons: "Nenhum motivo cadastrado. Clique em \"Adicionar Motivo\" para começar.",
        confirmDelete: "Tem certeza que deseja excluir este motivo?",
        toasts: {
          reasonNameRequired: "Nome do motivo é obrigatório",
          reasonUpdated: "Motivo atualizado com sucesso!",
          reasonCreated: "Motivo criado com sucesso!",
          reasonSaveError: "Erro ao salvar motivo",
          reasonDeleted: "Motivo excluído com sucesso!",
          reasonDeleteError: "Erro ao excluir motivo",
          configUpdated: "Configuração atualizada com sucesso!",
          configUpdateError: "Erro ao atualizar configuração",
        },
      },
      homePageCustomization: {
        loading: "Carregando configurações...",
        colorCustomization: "Personalização de Cores",
        primaryColor: "Cor Primária",
        backgroundColor: "Cor de Fundo",
        textColor: "Cor do Texto",
        accentColor: "Cor de Destaque",
        fontCustomization: "Personalização de Fontes",
        fontFamily: "Família da Fonte",
        fontSize: "Tamanho da Fonte (px)",
        contentCustomization: "Personalização de Conteúdo",
        heroSection: "Seção Hero (Principal)",
        badgeText: "Texto do Badge",
        mainTitle: "Título Principal",
        featuresSection: "Seção de Recursos",
        pricingSection: "Seção de Planos",
        ctaSection: "Seção de Chamada para Ação (CTA)",
        saveAll: "Salvar Todas as Configurações",
        toasts: {
          saveSuccess: "Configuração salva com sucesso!",
          saveError: "Erro ao salvar configuração",
          saveAllSuccess: "Todas as configurações foram salvas com sucesso!",
          saveSettingsError: "Erro ao salvar configurações",
        },
      },
      infoMp: {
        title: "Integração com Mercado Pago",
        intro: "Para começar a integrar seu sistema com o Mercado Pago, siga estes passos simples:",
        steps: {
          createAccount: "Crie uma conta no Mercado Pago Developers",
          createApp: "Crie uma aplicação no Mercado Pago Developers",
          productionCredentials: "Clique em Produção > Credenciais de produção",
          copyApiKey: "Clique em copiar e depois cole a chave em API key",
          webhooks: "No Mercado Pago, clique em notificações > webhooks",
          productionUrl: "Em modo produção, cole a seguinte URL \"{{url}}\" e marque a opção pagamentos em Eventos",
        },
      },
      options: {
        textMessageType: "Texto",
        automaticPositionNotifications: "Notificações Automáticas de Posição",
        minimumIntervalMinutes: "Intervalo Mínimo (minutos)",
        minimumPositionDifference: "Diferença Mínima de Posições",
        specialPositionMessage: "Mensagem Especial (Posição 1)",
        specialPositionPlaceholder: "Você é o próximo a ser atendido!",
        queuePositionHelper: "Digite @ para inserir variáveis dinâmicas (ex: {{name}}, {{position}}, {{queue}})",
        copyContactTab: "Configuração de Sigla para Cópia de Contato",
        removeCountryCode: "Remover código do país?",
        removeAreaCode: "Remover código de área (DDD)?",
        removeNinthDigit: "Remover nono dígito?",
        nameMsHelper: "Digite @ para inserir variáveis dinâmicas (ex: {{name}}, {{ms}})",
        nameQueueMsHelper: "Digite @ para inserir variáveis dinâmicas (ex: {{name}}, {{queue}}, {{ms}})",
        nameUserMsHelper: "Digite @ para inserir variáveis dinâmicas (ex: {{name}}, {{userName}}, {{ms}})",
      },
      uploaderCert: {
        certificateTab: "Certificado Efí - API PIX (p12)",
        chooseOption: "Escolha uma opção:",
        chooseCertificate: "Escolher Certificado Efí p12 API PIX",
        sendCertificate: "ENVIAR CERTIFICADO",
        toasts: {
          noPermission: "Sem permissão para acessar!",
          p12Only: "Use somente arquivos em formato p12!",
          chooseFile: "Escolha um arquivo!",
          chooseDestination: "Escolha um destino!",
          uploadSuccess: "Arquivo enviado com sucesso!",
        },
      },
    },
  },
  birthdaySettings: {
    title: "Configurações de Aniversário",
    loading: "Carregando configurações...",
    preview: "Pré-visualização:",
    userBirthdays: "Aniversários de Usuários",
    enableUserNotifications: "Habilitar notificações de aniversário de usuários",
    enableUserNotificationsHelp: "Quando habilitado, será exibido modal de parabéns e criado informativo automático",
    createUserAnnouncement: "Criar informativo automático para aniversários de usuários",
    createUserAnnouncementHelp: "Cria um informativo automático que é exibido para todos os usuários da empresa",
    userMessage: "Mensagem de aniversário para usuários",
    userMessageHelper: "Digite @ para inserir variáveis dinâmicas (ex: {{name}}, {{userName}})",
    contactBirthdays: "Aniversários de Contatos",
    enableContactMessages: "Habilitar envio automático de mensagens de aniversário para contatos",
    enableContactMessagesHelp: "Envia automaticamente mensagem de parabéns via WhatsApp para contatos aniversariantes",
    contactMessage: "Mensagem de aniversário para contatos",
    contactMessageHelper: "Digite @ para inserir variáveis dinâmicas (ex: {{name}}, {{firstName}})",
    testMessage: "Testar Mensagem",
    sendTime: "Horário de envio das mensagens",
    sendTimeHelper: "Horário em que as mensagens automáticas serão enviadas",
    whatsappConnection: "Conexão WhatsApp para Envio",
    selectConnection: "Selecione uma conexão",
    whatsappConnectionHelp: "Conexão WhatsApp que será usada para enviar mensagens de aniversário",
    createInternalAnnouncement: "Criar informativo interno para aniversários de usuários",
    createInternalAnnouncementHelp: "Cria um informativo interno quando um usuário faz aniversário",
    availableVariables: "Variáveis disponíveis nas mensagens:",
    personName: "Nome da pessoa",
    personAgeContactsOnly: "Idade da pessoa (apenas para contatos)",
    saveSettings: "Salvar Configurações",
    prompts: { testContactId: "Digite o ID de um contato para teste:" },
    toasts: {
      loadError: "Erro ao carregar configurações de aniversário",
      saveSuccess: "Configurações de aniversário salvas com sucesso!",
      saveError: "Erro ao salvar configurações",
      testSent: "Mensagem de teste enviada!",
      testError: "Erro ao enviar mensagem de teste",
    },
  },
  birthdayModal: {
    title: "Parabéns!",
    subtitle: "Hoje é um dia especial!",
    loading: "Carregando aniversariantes...",
    you: "Você!",
    systemUser: "Usuário do Sistema",
    contact: "Contato",
    ageOne: "{{count}} ano",
    ageOther: "{{count}} anos",
    sending: "Enviando...",
    messageAlreadySent: "Mensagem já enviada",
    sendCongrats: "Enviar Parabéns",
    remindLater: "Lembrar mais tarde",
    gotIt: "Entendi, obrigado!",
    toasts: {
      loadError: "Erro ao carregar aniversariantes",
      messageSent: "Mensagem de parabéns enviada para {{name}}!",
      alreadySent: "Mensagem de aniversário já foi enviada hoje para este contato",
      sendError: "Erro ao enviar mensagem de aniversário",
    },
  },
  scheduleModal: {
    errors: {
      alreadySentReadonly: "Este agendamento já foi enviado e não pode ser alterado.",
      validContactRequired: "Selecione um contato válido para o agendamento.",
    },
    titles: {
      sendError: "Erro de Envio",
      messageStatus: "Mensagem {{status}}",
      group: "Grupo",
    },
    readonlyNotice: "Este agendamento já foi enviado e não pode mais ser alterado.",
    form: {
      contact: "Contato",
      bodyHelper: "Digite @ para inserir variáveis dinâmicas (ex: {{name}}, {{dataAgendamento}}, {{ms}})",
      quickMessageSearch: "Digite para buscar respostas rápidas...",
      noQuickMessages: "Nenhuma resposta rápida encontrada",
    },
    reminder: {
      title: "Lembrete (Opcional)",
      description: "Defina uma data de lembrete. A mensagem será enviada no horário do lembrete em vez do horário original do agendamento",
      date: "Data do Lembrete",
      sameMessage: "A mensagem do lembrete será a mesma da mensagem agendada.",
    },
    quickMessageAttachment: "Da Resposta Rápida",
  },
  finalizacaoVendaModal: {
    title: "Finalização de Atendimento - Valor de Venda",
    loadingSettings: "Carregando configurações...",
    saleCompletedQuestion: "A venda foi concluída?",
    saleCompletedYes: "Sim, venda concluída",
    saleCompletedNo: "Não, venda não concluída",
    saleValue: "Valor da Venda (R$)",
    noSaleReason: "Motivo da Não Venda *",
    finalizationReason: "Motivo da Finalização *",
    selectReason: "Selecione um motivo",
    finishing: "Finalizando...",
    finishService: "Finalizar Atendimento",
    errors: {
      saleValueRequired: "Por favor, informe o valor da venda.",
      noSaleReasonRequired: "Por favor, selecione o motivo da não venda.",
      finalizationReasonRequired: "Por favor, selecione o motivo da finalização.",
    },
  },
  contactImport: {
    fields: { name: "Nome", number: "Número", birthDate: "Data de Nascimento", wallet: "Carteira" },
    validateContacts: "Validar contatos no WhatsApp",
    importingWait: "Importando... Aguarde",
    importContacts: "Importar contatos",
    importResult: "Resultado da importação",
    contactsCreated: "{{count}} contatos criados com sucesso",
    contactsIgnored: "{{count}} contatos ignorados (número inválido ou não marcados para atualizar)",
    importMore: "Importar mais contatos",
    processingFile: "Processando arquivo...",
    invalidFileTitle: "Arquivo inválido!",
    invalidFileDescription: "O arquivo que você tentou importar não é válido. Por favor, tente novamente com um arquivo no formato correto.",
    tryAgain: "Tentar novamente",
    uploadAlt: "Upload",
    dropExcel: "Clique ou arraste um arquivo Excel",
    acceptedFormats: "* Formatos aceitos: xls, xlsx, csv, txt",
    requiredColumnsHelp: "Para importar contatos, você deve ter pelo menos as colunas de nome e número de telefone.",
    errors: {
      numberFieldRequired: "Não foi selecionado o campo de número do contato",
      nameFieldRequired: "Não foi selecionado o campo de nome do contato",
      noContactsSelected: "Nenhum contato selecionado",
      fieldAlreadySelected: "O campo {{field}} já foi selecionado.",
    },
    toasts: {
      importSuccess: "Importação realizada com sucesso! {{count}} contatos importados.",
      importWithIgnored: "Importação concluída: {{imported}} contatos importados e {{ignored}} ignorados.",
      importFailed: "Falha na importação. Nenhum contato foi importado.",
    },
  },
  plansManager: {
    queues: "Filas",
    amount: "Valor",
    internalChat: "Chat Interno",
    externalApi: "API Externa",
    integrations: "Integrações",
    tableAria: "tabela de planos",
    deleteTitle: "Exclusão de Registro",
    deleteMessage: "Deseja realmente excluir esse registro?",
    toasts: {
      loadError: "Não foi possível carregar a lista de registros",
      operationValidationError: "Não foi possível realizar a operação. Verifique se já existe um plano com o mesmo nome ou se os campos foram preenchidos corretamente",
      operationError: "Não foi possível realizar a operação",
    },
  },
  companiesManager: {
    tableAria: "tabela de empresas",
  },
  quickMessageDialog: {
    official: "Oficial",
    messageHelper: "Digite @ para inserir variáveis dinâmicas (ex: {{name}}, {{userName}}, {{ms}})",
    attachMedia: "Anexar Mídia",
    editMedia: "Editar mídia",
    removeMedia: "Remover mídia",
    newFile: "Novo Arquivo",
    newRecordedAudio: "Novo áudio gravado",
    newAudio: "Novo Áudio",
    chooseReplacementMedia: "Escolha uma nova mídia para substituir:",
    chooseMediaOption: "Escolha uma opção para anexar mídia:",
    attachFile: "Anexar Arquivo",
    recordAudio: "Gravar Áudio",
    cancelEdit: "Cancelar Edição",
    type: "Tipo",
    value: "Valor",
  },
  whatsAppModal: {
    toasts: { clickSaveToRegister: "Clique em salvar para registrar as alterações" },
    tabs: { chatbot: "Chatbot", defaultFlow: "Fluxo Padrão" },
    variableHelperNameMs: "Digite @ para inserir variáveis dinâmicas (ex: {{name}}, {{ms}})",
    welcomeFlowTitle: "Fluxo de boas vindas",
    welcomeFlowDescription: "Este fluxo é disparado apenas para novos contatos, pessoas que você não possui em sua lista de contatos e que mandaram uma mensagem",
  },
});

mergeTranslations(messages.pt.translations, {
  chatMessages: {
    loadingOlderMessages: "Carregando mensagens antigas...",
    doubleClickToReply: "Clique duas vezes para responder",
    userFallback: "Usuário",
    cancelRecording: "Cancelar gravação",
    sendRecordedAudio: "Enviar áudio gravado",
    cancelUpload: "Cancelar upload",
    sendUpload: "Enviar upload",
    emojiPicker: "Selecionar emoji",
    showRecorder: "Mostrar gravador",
    upload: "Enviar arquivo",
    messageFallback: "Mensagem",
    audioMessage: "Mensagem de áudio",
    messageNotFound: "[mensagem não encontrada]",
  },
  cameraModal: {
    previewAlt: "Pré-visualização",
    retakePhoto: "Tirar outra foto",
    confirmPhoto: "Confirmar foto",
    capturePhoto: "Capturar foto",
    errors: {
      access: "Não foi possível acessar a câmera.",
      notFound: "Nenhuma câmera encontrada neste dispositivo. Por favor, use a opção de anexar imagem para enviar uma foto.",
      permissionDenied: "Permissão de câmera negada. Por favor, permita o acesso à câmera nas configurações do navegador.",
      inUse: "A câmera está sendo usada por outro aplicativo. Feche outros aplicativos que possam estar usando a câmera.",
      unsupported: "As configurações da câmera não são suportadas. Tente usar outro dispositivo.",
      accessWithDetails: "Não foi possível acessar a câmera: {{details}}",
    },
  },
  modalImageCors: {
    image: "Imagem",
    downloadImage: "Baixar imagem",
    sentAt: "Enviada em {{date}}",
    receivedAt: "Recebida em {{date}}",
    imageZoom: "Zoom da imagem",
  },
  pdfPreview: {
    loadError: "Erro ao carregar arquivo",
    downloadFile: "Baixar arquivo",
    clickToDownload: "Clique para baixar",
  },
  audioRecorder: {
    microphoneAccessError: "Erro ao acessar o microfone. Verifique as permissões.",
    recordAudio: "Gravar Áudio",
    recording: "Gravando...",
    recordedAudio: "Áudio gravado",
    confirmOrDelete: "Clique em confirmar para confirmar ou excluir para remover",
  },
  filters: {
    connections: "Selecione as conexões",
    contacts: "Contatos",
    tags: "Filtro por Tags",
    channels: "Selecione os canais",
    queues: "Selecione as filas",
    users: "Selecione os atendentes",
  },
});

mergeTranslations(messages.pt.translations, {
  kanban: {
    toasts: {
      ticketTagUpdated: "Ticket Tag atualizado com sucesso!",
      ticketTagRemoved: "Ticket Tag removido!",
      adminOnlyReorder: "Apenas administradores podem reordenar as lanes do Kanban",
      lanesOrderUpdated: "Ordem das lanes atualizada com sucesso",
      lanesOrderSaveError: "Erro ao salvar ordem das lanes",
    },
    sort: {
      label: "Ordenar por",
      ticketNumber: "Número do Ticket",
      lastMessage: "Última Mensagem",
      valueDesc: "Valor (maior para menor)",
      startDate: "Data de início",
      endDate: "Data de fim",
    },
    card: {
      ticketNumber: "Ticket nº {{id}}",
      valueWithAmount: "Valor: R$ {{amount}}",
      assignValue: "Atribuir Valor",
      remove: "Remover",
      viewTicket: "Ver Ticket",
      editOpportunityValue: "Editar Valor da Oportunidade",
      assignOpportunityValue: "Atribuir Valor da Oportunidade",
      value: "Valor",
    },
  },
  contactModal: {
    placeholders: {
      email: "Endereço de email",
    },
    form: {
      lid: "LID (Linked Device ID)",
      jid: "JID (WhatsApp ID)",
      birthDate: "Data de Nascimento",
    },
    helpers: {
      lid: "Identificador do dispositivo vinculado",
      jid: "Identificador completo do WhatsApp (JID)",
      birthDate: "Data de nascimento para mensagens automáticas de aniversário",
      noFloup: "Este contato não está em nenhum Floup no momento",
    },
    floup: {
      currentStep: "{{name}} - Etapa {{current}} de {{total}}",
      nextRun: "Próxima execução: {{date}}",
      active: "Floup ativo",
      noneActive: "Nenhum Floup ativo",
    },
  },
  queueModal: {
    toasts: {
      clickSaveToRegister: "Clique em salvar para registrar as alterações",
    },
    tabsAria: "Abas de configurações da fila",
    minutes: {
      one: "1 minuto",
      two: "2 minutos",
      three: "3 minutos",
      four: "4 minutos",
      five: "5 minutos",
      ten: "10 minutos",
      fifteen: "15 minutos",
      thirty: "30 minutos",
      fortyFive: "45 minutos",
      sixty: "60 minutos",
    },
    randomMode: {
      random: "Aleatório",
      ordered: "Ordenado",
    },
    form: {
      selectRandomMode: "Selecione o tipo de rodízio",
    },
  },
  userModal: {
    form: {
      birthDate: "Data de Nascimento",
      birthDateHelper: "Data de nascimento para notificações de aniversário",
      saleFinalization: "Finalização com Valor de Venda",
      enabled: "Habilitado",
      disabled: "Desabilitado",
    },
    status: {
      unknown: "Desconhecido",
      online: "Online",
      offline: "Offline",
    },
  },
  notifications: {
    openNotifications: "Abrir notificações",
  },
});

mergeTranslations(messages.pt.translations, {
  campaignsPhrase: {
    title: "Campanhas de Fluxo",
    buttons: {
      new: "Nova Campanha",
    },
    columns: {
      name: "Nome",
      connections: "Conexões",
      status: "Status",
    },
    toasts: {
      deleted: "Campanha deletada com sucesso",
    },
    tooltips: {
      edit: "Editar campanha",
      delete: "Excluir campanha",
    },
    empty: {
      title: "Nenhuma campanha encontrada",
      description: "Clique em \"Nova Campanha\" para criar sua primeira campanha de fluxo",
    },
    fallbacks: {
      noName: "Nome não definido",
    },
    noConnection: "Nenhuma conexão",
    moreConnections: "Mais {{count}} conexão(ões)",
    configuredPhrases: "{{count}} frase(s) configurada(s)",
  },
  dashboard: {
    toasts: {
      ticketInfoError: "Erro ao buscar informações dos tickets",
    },
    heatmap: {
      title: "Heatmap de Atendimento",
      description: "Quantidade de atendimentos iniciados por dia da semana e hora.",
      hourRange: "{{start}}:00 às {{end}}:59",
      attendances: "{{count}} atendimento(s)",
      ticketDetails: "Ticket #{{ticketId}} | Contato: {{contact}} | Número: {{number}} | Status: {{status}} | Atendente: {{user}}",
      ticketMeta: "Número: {{number}} | Status: {{status}} | Atendente: {{user}}",
      additionalTickets: "+ {{count}} ticket(s) adicional(is)",
      peak: "Pico no período: {{count}} atendimento(s) iniciados em uma hora.",
      lower: "Menor",
      higher: "Maior",
      dialogTitle: "{{day}} | {{hourRange}} | {{count}} atendimento(s)",
      noName: "Sem nome",
      shortDays: {
        sunday: "Dom",
        monday: "Seg",
        tuesday: "Ter",
        wednesday: "Qua",
        thursday: "Qui",
        friday: "Sex",
        saturday: "Sáb",
      },
      days: {
        sunday: "Domingo",
        monday: "Segunda-feira",
        tuesday: "Terça-feira",
        wednesday: "Quarta-feira",
        thursday: "Quinta-feira",
        friday: "Sexta-feira",
        saturday: "Sábado",
      },
    },
  },
  users: {
    table: {
      avatar: "Avatar",
    },
    toasts: {
      chatCreated: "Chat criado com sucesso!",
      chatsGenerated: "Chats gerados com sucesso!",
    },
    confirmations: {
      backfillChats: "Tem certeza que deseja gerar chats para todos os usuários existentes? Isso pode demorar e criar muitos chats.",
    },
  },
  signup: {
    form: {
      plan: "Plano",
    },
  },
  prompts: {
    toasts: {
      noPermissionRedirect: "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.",
    },
  },
  announcements: {
    toasts: {
      noPermissionRedirect: "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.",
    },
  },
  companies: {
    toasts: {
      noPermissionRedirect: "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.",
    },
  },
  queueIntegration: {
    toasts: {
      noPermissionRedirect: "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.",
    },
  },
});

mergeTranslations(messages.pt.translations, {
  common: {
    understood: "Entendi",
    noName: "Sem nome",
    error: "Erro",
    table: {
      actions: "Ações",
    },
  },
  contactListItems: {
    toasts: {
      bulkDeleted: "{{count}} contatos excluídos com sucesso!",
      bulkDeleteError: "Erro ao excluir contatos",
    },
    confirmationModal: {
      downloadExample: "Clique aqui para baixar planilha exemplo.",
      deleteSelectedTitle: "Excluir {{count}} contatos selecionados?",
      deleteSelectedMessage: "Tem certeza que deseja excluir os contatos selecionados? Esta ação não pode ser desfeita.",
    },
    bulk: {
      pageSelected: "Todos os {{count}} contatos desta página foram selecionados.",
      selectAllList: "Selecionar todos os {{count}} contatos desta lista",
      allSelected: "Todos os {{count}} contatos desta lista estão selecionados.",
      clearSelection: "Limpar seleção",
    },
    table: {
      photo: "Foto",
    },
    tooltips: {
      whatsappValid: "WhatsApp Válido",
      whatsappInvalid: "WhatsApp Inválido",
    },
    importProgress: {
      importing: "Importando contatos ({{percent}}%)",
      total: "Total na planilha: {{count}}",
      toImport: "Serão importados: {{count}}",
      processed: "Processados: {{count}}",
      imported: "Importados: {{count}}",
      existing: "Já existentes: {{count}}",
      duplicated: "Duplicados: {{count}}",
      errors: "Com erro: {{count}}",
      existingTitle: "Contatos já existentes na lista:",
      duplicatedTitle: "Contatos duplicados detectados:",
      errorTitle: "Contatos com erro:",
      noExistingDetails: "Nenhum item detalhado foi retornado para os já existentes.",
      noDuplicatedDetails: "Nenhum item detalhado foi retornado para exibição, apesar da contagem de duplicados.",
      noErrorDetails: "Nenhum item detalhado foi retornado para os erros.",
    },
  },
  contactNotes: {
    toasts: {
      added: "Observação adicionada com sucesso!",
      deleted: "Observação excluída com sucesso!",
    },
    confirmation: {
      deleteTitle: "Excluir Registro",
      deleteMessage: "Deseja realmente excluir este registro?",
    },
    editModal: {
      title: "Editar Observação",
      label: "Editar Observação",
    },
  },
  checkoutPage: {
    steps: {
      data: "Dados",
      customize: "Personalizar",
      review: "Revisar",
    },
    notFound: "Não encontrado",
    total: "TOTAL",
    copied: "Copiado",
    copyPixQrCode: "Copiar código QR PIX",
    usersCount: "{{count}} Usuários",
    connectionsCount: "{{count}} Conexão",
    decreaseUsers: "Diminuir usuários",
    increaseUsers: "Aumentar usuários",
    decreaseConnections: "Diminuir conexões",
    increaseConnections: "Aumentar conexões",
    toasts: {
      subscriptionSuccess: "Assinatura realizada com sucesso!, aguardando a realização do pagamento",
      licenseRenewed: "Sua licença foi renovada até {{date}}!",
    },
    form: {
      fullName: "Nome completo*",
      lastName: "Sobrenome*",
      address: "Endereço*",
      city: "Cidade*",
      state: "Estado*",
      document: "CPF/CNPJ*",
      country: "País*",
      useAddressForPayment: "Usar este endereço para os dados de pagamento",
      nameOnCard: "Nome no cartão*",
      cardNumber: "Número do cartão*",
      expiryDate: "Data de validade*",
      cvv: "CVV*",
    },
    validation: {
      fullNameRequired: "O nome completo é obrigatório",
      lastNameRequired: "O sobrenome é obrigatório",
      addressRequired: "O endereço é obrigatório",
      cityRequired: "Cidade é obrigatória",
      stateRequired: "Estado é obrigatório",
      zipcodeRequired: "CEP é obrigatório",
      zipcodeInvalid: "Formato de CEP inválido",
      countryRequired: "País é obrigatório",
      nameOnCardRequired: "Nome no cartão é obrigatório",
      cardNumberRequired: "Número do cartão é obrigatório",
      cardNumberInvalid: "Número do cartão inválido (ex: 4111111111111)",
      expiryDateRequired: "Data de validade é obrigatória",
      expiryDateInvalid: "Data de validade inválida",
      cvvRequired: "CVV é obrigatório",
      cvvInvalid: "CVV inválido (ex: 357)",
    },
    review: {
      paymentInfo: "Informação de pagamento",
      email: "Email:",
      name: "Nome:",
      document: "CPF/CNPJ:",
      planDetails: "Detalhes do plano",
      users: "Usuários: {{count}}",
      connections: "Conexão: {{count}}",
      queues: "Filas: {{count}}",
      billingMonthly: "Cobrança: Mensal",
    },
  },
  messagesList: {
    emptyNewContact: "Diga olá para seu novo contato!",
    dropFileHere: "Solte o arquivo aqui",
    unsupportedMediaType: "Tipo de mídia não suportado",
    audioMessage: "Mensagem de áudio",
  },
  floupSelector: {
    toasts: {
      stopped: "Follow UP interrompido com sucesso",
    },
    stopFollowUp: "Parar Follow UP",
    active: "Ativo",
    nextSteps: "Próximos passos:",
    infoTitle: "Informações sobre Follow UP",
    selectFollowUp: "Selecionar Follow UP",
    chooseTemplate: "Escolher template...",
    customTemplate: "personalizado",
    aboutTitle: "Sobre o Sistema Follow UP",
    aboutDescriptionPrefix: "O",
    aboutDescriptionSuffix: "permite criar fluxos de mensagens e atribuí-los a um contato ou ticket para execução automática.",
    aboutHint: "Selecione um template ativo para iniciar. Você pode interromper a qualquer momento.",
  },
  whatsAppModal: {
    defaultResponseFlow: {
      title: "Fluxo de resposta padrão",
      description: "Resposta Padrão é enviada com qualquer caractere diferente de uma palavra chave. ATENÇÃO! Será disparada se o atendimento já estiver fechado.",
    },
  },
  whatsAppModalAdmin: {
    toasts: {
      clickSaveToRegister: "Clique em salvar para registrar as alterações",
    },
    tabs: {
      chatbot: "Chatbot",
    },
  },
  templateMetaModal: {
    title: "Templates do WhatsApp",
    searchPlaceholder: "Pesquisar Templates",
    language: "Idioma: {{language}}",
    templateContent: "Conteúdo do Template: {{content}}",
    category: "Categoria: {{category}}",
    selectedDetails: "Detalhes do Template Selecionado",
    name: "Nome: {{name}}",
    content: "Conteúdo: {{content}}",
  },
  quickMessagesTable: {
    shortcut: "Atalho",
    message: "Mensagem",
  },
  contactListTable: {
    name: "Nome",
    contacts: "Contatos",
  },
  queueOptions: {
    titlePlaceholder: "Título da opção",
    undefinedTitle: "Título não definido",
    messagePlaceholder: "Digite o texto da opção",
  },
});

mergeTranslations(messages.pt.translations, {
  avatarUpload: {
    errors: {
      unsupportedFormat: "Formato de arquivo não suportado. Use apenas JPG, PNG, GIF ou WebP.",
      fileTooLarge: "Arquivo muito grande. Tamanho máximo: 5MB",
    },
    alt: {
      userAvatar: "Avatar do usuário",
    },
    changeAvatar: "Alterar Avatar",
    uploadAvatar: "Upload Avatar",
  },
  notificationsVolume: {
    openNotifications: "Abrir notificações",
  },
  darkMode: {
    toggle: "Alternar modo escuro",
  },
  ticketActionButtonsCustom: {
    toasts: {
      ticketClosed: "Ticket finalizado com sucesso!",
    },
    buttons: {
      createNewTicket: "Criar Novo Ticket",
    },
    tooltips: {
      linkWallet: "Vincular à minha carteira",
      copyPhoneWithPrefix: "Copiar telefone com prefixo ({{prefix}})",
    },
    aria: {
      userMenu: "Conta do usuário atual",
    },
  },
  speedDialButton: {
    openActionsMenu: "Abrir menu de ações",
  },
  dashboard: {
    attendantsStatus: {
      online: "Online",
      offline: "Offline",
    },
  },
  wavoipCall: {
    connected: "Conectado",
    disconnected: "Desconectado",
    minimize: "Minimizar",
    enterNumber: "Digite um número",
    subtitle: "Faça chamadas via WhatsApp",
    incomingCall: "Chamada recebida",
    unknownNumber: "Número desconhecido",
    callStatus: {
      inCall: "Em chamada",
      connecting: "Conectando...",
      calling: "Chamando...",
    },
    errors: {
      numberTooShort: "Número muito curto",
      numberTooLong: "Número muito longo",
      invalidNumber: "Número inválido",
    },
  },
  login: {
    aria: {
      togglePasswordVisibility: "Alternar visibilidade da senha",
    },
  },
  flowBuilder: {
    status: {
      active: "Ativo",
      inactive: "Inativo",
    },
    aria: {
      createFlow: "Criar fluxo",
    },
  },
  chat: {
    aria: {
      mainMailboxFolders: "Pastas principais da caixa de entrada",
      more: "Mais",
    },
  },
  messagesInput: {
    cancelForward: "Cancelar encaminhamento",
  },
  chatBots: {
    toasts: {
      saved: "Bot salvo com sucesso",
      queueDeleted: "Fila excluída com sucesso!",
    },
    optionTypes: {
      text: "Texto",
      attendant: "Atendente",
      queue: "Fila",
      integration: "Integração",
      file: "Arquivo",
    },
    tooltips: {
      messageRequired: "A mensagem é obrigatória para seguir ao próximo nível",
      messageRequiredContent: "Se a mensagem não estiver definida, o bot não seguirá adiante",
    },
  },
});

mergeTranslations(messages.pt.translations, {
  mainDrawer: {
    listItems: {
      globalSearch: "Pesquisa Global",
    },
  },
  bootLoader: {
    loadingSubtitle: "Carregando sua experiência...",
    initializingApplication: "Inicializando aplicação...",
    loadingComponents: "Carregando componentes...",
    configuringInterface: "Configurando interface...",
    connectingServices: "Conectando serviços...",
    preparingSystem: "Preparando o sistema...",
    finishingLoading: "Finalizando carregamento...",
  },
  tagsContainer: {
    placeholder: "Tags",
    loadingTags: "Carregando tags...",
    noTagsFound: "Nenhuma tag encontrada. Digite para criar uma nova.",
  },
  whitelabel: {
    loadingSettings: "Carregando configurações...",
  },
  billingEntitlements: {
    BILLING_RESOURCE_BLOCKED: "Recurso bloqueado pelo plano.",
    PLAN_FEATURE_DISABLED: "Este recurso não está incluído no seu plano.",
    PLAN_LIMIT_REACHED: "O limite do plano foi atingido.",
    PLAN_USER_LIMIT_REACHED: "Seu plano atingiu o limite de usuários.",
    PLAN_CONNECTION_LIMIT_REACHED: "Seu plano atingiu o limite de conexões.",
    SUBSCRIPTION_NOT_ACTIVE: "Sua assinatura não está ativa.",
    SUBSCRIPTION_SUSPENDED: "Sua assinatura está suspensa.",
    BILLING_MANUAL_REVIEW_REQUIRED: "Este acesso requer revisão manual.",
    BILLING_STATUS_UNKNOWN: "O status financeiro precisa de revisão.",
    ENTITLEMENT_RESOLUTION_FAILED: "Não foi possível validar o acesso agora.",
    CAMPAIGN_WAITING_FOR_BILLING: "Sua campanha permanece aguardando até que o acesso seja regularizado.",
    SCHEDULE_WAITING_FOR_BILLING: "O agendamento permanece aguardando regularização financeira."
  },
});

export { messages };
